{
  "404.message": "お探しのページは存在しません。考えられる理由は以下のとおりです。",
  "404.message.reason1": "ページが存在しません。",
  "404.message.reason2": "ページは存在しますが、表示権限がありません。",
  "404.nav.dashboard": "自分のダッシュボード",
  "404.nav.home": "サイト ホームページ",
  "404.nav.title": "移動",
  "404.search.title": "サイト検索",
  "aboutpage.section.title": "Atlassian Confluence CloudとConfluence Cloudプラグイン",
  "accessibility.user.icon": "ユーザー アイコン",
  "action.add.comment": "コメントの追加",
  "action.edit.comment": "コメントの編集",
  "action.reorder.pages.sentence": "ページの順序変更",
  "action.space.addons": "アドオン",
  "action.space.overview": "概要",
  "actions.word": "操作",
  "add.comment": "コメントの追加",
  "add.comment.accesskey": "m",
  "add.shortcut": "ショートカットを作成",
  "add.word": "追加",
  "addlabels.teamlabels": "カテゴリ",
  "adf.translation.error.in.render.description.prod": "ページを更新しもう一度試してください。問題が継続する場合は、<a target=\"_blank\" href=\"{link}\">アトラシアン サポート</a>までお問い合わせください。",
  "adf.translation.error.in.render.description.staging": "ADF のエラーによりコンテンツを表示できません。Slack 内の <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> チャンネルで詳しく確認してください。",
  "adf.translation.error.in.render.title.prod": "コンテンツを表示できませんでした",
  "adf.translation.error.in.render.title.staging": "コンテンツの表示中に ADF エラー",
  "adg3.feedback.placeholder": "Confluenceをさらに良い製品にするために、あなたのConfluenceのご使用体験について教えてください。",
  "adg3.give.feedback": "フィードバックを送信",
  "adg3.onboarding.docs.link": "詳細",
  "adg3.onboarding.next": "次",
  "adg3.onboarding.prev": "前",
  "adg3.onboarding.sidebar.done": "分かりました",
  "adg3.onboarding.skip": "スキップ",
  "adg3.onboarding.start": "はじめる",
  "adg3.onboarding.step1.content": "色やアイコン、フォントを更新しました。重要事項が見つけやすくなり、目の負担が減ります。",
  "adg3.onboarding.step1.title": "新しいConfluence体験へようこそ",
  "adg3.onboarding.step2.content": "最も必要な作業 (検索、作成、ナビゲーション) は、すべてサイドバーにあります。",
  "adg3.onboarding.step2.title": "シンプルなサイドバーナビゲーション",
  "adg3.onboarding.step3.content": "作業内容を忘れましたか? 検索パネルで、最近表示したページのリストを見ることができます。",
  "adg3.onboarding.step3.title": "前回中断した場所を選んでください",
  "adg3.onboarding.step4.content": "あなたのプロファイルから改善のためのフィードバックにご協力ください。まだ新しい体験をする準備ができていない場合は、プロファイルから中止してください。",
  "adg3.onboarding.step4.content.no.optout": "あなたからのフィードバックはConfluenceの体験を改善する上でとても重要です。プロフィールからご意見をお聞かせいただき、Confluenceの改善にご協力ください。",
  "adg3.onboarding.step4.title": "ベストのConfluenceの構築にご協力ください",
  "adg3.onboarding.user.optin.content": "今回フィードバックに基づいていくつかの変更を加えましたが、今後も改善は続けていきます。他にもご意見がおありの場合は、サイドバーにある「Give feedback (フィードバックを送る)」からお寄せください。",
  "adg3.onboarding.user.optin.done": "了解しました",
  "adg3.onboarding.user.optin.title": "新しい複合体験が今、どなたにもご利用いただけるようになりました",
  "adg3.send.feedback": "フィードバックを送信",
  "adg3.sidebar.button.configure": "サイドバーの設定",
  "adg3.sidebar.button.done": "完了",
  "adg3.sidebar.button.gotit": "わかりました",
  "adg3.sidebar.link.disable": "無効化",
  "adg3.sidebar.link.enable": "有効化",
  "adg3.user.profile.other": "マイ Confluence",
  "admin.section.security.title": "ユーザー & セキュリティ",
  "administration.name": "管理",
  "all.updates.mainBanner": "あまり動きもなく静かです...今のところ",
  "all.updates.subBanner": "このサイトの最新の状況を把握しましょう。新規ページ、ファイル、編集、コメントがこちらに表示されます。",
  "all.updates.subBanner2": "次の傑作を生み出す時です。",
  "all.updates.title": "すべての更新",
  "anonymous.name": "匿名",
  "archived.spaces": "アーカイブ スペース",
  "atlassian.can.contact": "お客様のフィードバックをフォローするため、ご連絡差し上げてよろしいでしょうか?",
  "atlassian.home.name": "Atlassian ホーム",
  "attach.files.no.permission": "ここにファイルを挿入するには権限が必要です。",
  "attach.files.tip.close": "わかりました!",
  "attach.files.tip.desc": "ファイルをページに直接挿入するには、ページにそのままドロップします。",
  "attach.files.tip.title": "ヒント:",
  "attach.files.upload.files": "ファイルをアップロード",
  "attach.files.upload.images": "画像をアップロード",
  "audit.logging.category.user.management": "ユーザーとグループ",
  "aui.sidebar.collapse.tooltip": "サイドバーを折りたたむ ( [ )",
  "aui.sidebar.expand.tooltip": "サイドバー( [ )を展開する",
  "author.name": "作成者",
  "blog.personal.name": "個人のブログ",
  "blog.post": "ブログ投稿",
  "blog.word": "ブログ",
  "blogtree.failed.load.content": "ブログの投稿を読み込めませんでした",
  "blueprint.navigation.items.create.new.template": "新規テンプレートの作成",
  "blueprint.navigation.items.create.new.template.disabled": "スペース管理者のみがテンプレートを作成できます",
  "blueprint.navigation.items.filter.for.templates": "テンプレートをフィルター",
  "blueprint.navigation.items.page.templates.header": "ページ テンプレート",
  "button.cancel": "取消",
  "cache.name.com.atlassian.confluence.pages.Draft": "下書き",
  "calendar.share.button.keyboard.shortcut.desc": "共有",
  "calendar3.addcalendar": "カレンダーを追加する",
  "calendar3.helptip.learn.more": "詳細",
  "calendar3.spacecalendars.header": "カレンダー",
  "calendar3.spacecalendars.onboarding.button.add.label": "カレンダーを追加",
  "calendar3.spacecalendars.onboarding.intro": "カレンダーを追加して、あなたのチームの休暇を追跡し、Jiraプロジェクトを計画して、全員が重要な日程近くに足並みが揃うようにします。",
  "calendar3.spacecalendars.onboarding.title": "あなたのチームまたはプロジェクトについて信頼できる情報源",
  "cancel.name": "キャンセル",
  "captcha.response.failed": "入力した単語は画像内のテキストと一致していません。",
  "categories.name": "カテゴリ",
  "changeboarding.dnd.pagetree.spacesettings.banner": "サイドバーでドラッグアンドでページの順番を変更できるようになり、スペースの管理が簡単になりました",
  "changeboarding.dnd.pagetree.spotlight.message": "ドラッグ＆ドロップでページ間の移動やスペースの整理を行ってください。",
  "changes-diff.heading.key": "キー",
  "changes-diff.these.lines.were.added": "この行は追加されました。",
  "changes-diff.these.lines.were.removed": "この行は削除されました。",
  "changes-diff.this.content.was.modified": "書式設定が変更されました。",
  "clear.name": "クリアする",
  "clipboardaccess.browser.not.supported": "お使いのブラウザはクリップボードからの画像の貼り付けをサポートしていません。",
  "clipboardaccess.ok": "OK",
  "close.draft.name": "下書きを閉じる",
  "close.name": "閉じる",
  "collab.edit.user.limit.msg.body": "<p>このページはとても人気があり、同時編集者の最大数に達しています。</p><p>混雑していないときに再度お試しください</p>",
  "collab.edit.user.limit.msg.title": "現在、このページを編集することはできません",
  "collab.status.connected": "準備ができています",
  "collab.status.connecting": "接続中...",
  "collab.status.error": "変更を保存することができません。",
  "collab.status.tooltip.error": "あなたの作業をコピーして、ページをリフレッシュしてください、そうすればこちらで再接続をします。",
  "collab.status.tooltip.failure": "サーバーにつながりません。インターネットの接続を確認してください。お客様への再接続を継続します。",
  "collab.status.tooltip.success": "すべての変更を下書きに自動で保管しています。",
  "collapse.name": "折りたたむ",
  "colourname.property.style.bordercolour": "枠線と区切り線",
  "colourname.property.style.breadcrumbstextcolour": "トップ バーの文字",
  "colourname.property.style.headerbuttonbasebgcolour": "ヘッダー ボタンの背景",
  "colourname.property.style.headerbuttontextcolour": "ヘッダー ボタンの文字",
  "colourname.property.style.headingtextcolour": "見出しの文字",
  "colourname.property.style.linkcolour": "リンク",
  "colourname.property.style.menuitemselectedbgcolour": "メニュー項目選択時の背景",
  "colourname.property.style.menuitemselectedtextcolour": "メニュー項目選択時の文字",
  "colourname.property.style.menuitemtextcolour": "ページ メニュー項目の文字",
  "colourname.property.style.menuselectedbgcolour": "ページ メニュー選択時の背景",
  "colourname.property.style.navbgcolour": "タブ ナビゲーションの背景",
  "colourname.property.style.navselectedbgcolour": "タブ ナビゲーションの背景の強調色",
  "colourname.property.style.navselectedtextcolour": "タブ ナビゲーションの文字の強調色",
  "colourname.property.style.navtextcolour": "タブ ナビゲーションの文字",
  "colourname.property.style.searchfieldbgcolour": "検索フィールド背景",
  "colourname.property.style.searchfieldtextcolour": "検索フィールド テキスト",
  "colourname.property.style.spacenamecolour": "スペース名の文字",
  "colourname.property.style.topbarcolour": "トップ バー",
  "colourname.property.style.topbarmenuitemtextcolour": "トップ バー メニュー項目の文字",
  "colourname.property.style.topbarmenuselectedbgcolour": "トップ バー メニュー選択時の背景",
  "colourname.property.style.topbarmenuselectedtextcolour": "トップ バー メニュー選択時の文字",
  "com.atlassian.confluence.contributors.contributors.label": "投稿者",
  "com.atlassian.confluence.extra.officeconnector.viewfile.label": "ファイルの表示",
  "com.atlassian.confluence.extra.team-calendars.calendar.helptip.close": "どうもありとうございます!",
  "com.atlassian.confluence.pages.actions.EditPageAction.action.name": "ページの編集",
  "com.atlassian.confluence.plugins.confluence-roadmap-plugin.roadmap.label": "Roadmap Planner",
  "com.atlassian.confluence.plugins.pagetree.pagetree.label": "ページ ツリー",
  "com.atlassian.confluence.plugins.recently.viewed.filter": "フィルター",
  "com.atlassian.confluence.plugins.recently.viewed.footer.hint": "ヒント : \"g\" に続けて \"r\" を入力すると、このメニューを素早く開けます",
  "com.atlassian.confluence.plugins.recently.viewed.title": "最近表示されたページ",
  "com.atlassian.confluence.plugins.status-macro.status.label": "ステータス",
  "com.atlassian.mywork.header.notifications": "通知",
  "comment.display.name.anonymous": "匿名",
  "comment.edit": "編集",
  "comment.edited": "編集:",
  "comment.name.tooltip": "コメントの追加",
  "comment.notification.enable": "このページをウォッチ",
  "comment.permalink": "固定リンク",
  "comment.plural": "{0} コメント",
  "comment.remove": "削除",
  "comment.reply": "返信",
  "comment.singular": "1 コメント",
  "compare.selected": "選択したバージョンを比較",
  "configuration.name": "構成",
  "confluence.extra.attachments.attachments.label": "添付ファイル",
  "confluence.extra.jira.jira.label": "Jira",
  "confluence.extra.masterdetail.detailssummary.label": "ページ プロパティ レポート",
  "confluence.home": "Confluence ホーム",
  "confluence.macros.advanced.children.label": "子表示",
  "confluence.macros.advanced.contentbylabel.label": "ラベル別コンテンツ",
  "confluence.macros.advanced.recently-updated.label": "最近の更新",
  "confluence.mobile.nav.switch.to.mobile.action": "Confluenceモバイルに切り替えてください",
  "confluence.mobile.nav.switch.to.mobile.text": "現在、モバイル機器でデスクトップ版をご覧になっています。",
  "confluence.mobile.refresh": "更新",
  "confluence.request.access.pagerestricted.inherited.description": "これは、親ページからの制限を受け継いでいるためです。スペース管理者またはこのページを共有した人から、アクセスを付与してもらえる可能性があります。",
  "confluence.request.access.pagerestricted.request.access.button": "アクセスをリクエスト",
  "confluence.request.access.pagerestricted.requestaccess.description": "「アクセスをリクエスト」ボタンを押してください。アクセスを与えることのできる人をこちらでお探しします。",
  "confluence.request.access.pagerestricted.requestaccess.title.edit.page": "このページを編集する権限がありません",
  "confluence.request.access.pagerestricted.requestaccess.title.view.page": "このページを表示する権限がありません",
  "confluence.user.profile.department": "部門",
  "confluence.user.profile.location": "場所",
  "confluence.user.profile.position": "役職",
  "connect.addon.wait.or": "待機または",
  "content.empty": "コメント テキストに何も入力されていません。空のコメントは作成できません。",
  "content.kind.decisions": "決定",
  "content.kind.file-list": "ファイル一覧",
  "content.kind.jirareport": "Jira レポート",
  "content.kind.kb-how-to-article": "ハウツー記事",
  "content.kind.kb-troubleshooting-article": "トラブルシューティング記事",
  "content.kind.meeting-notes": "ミーティング議事録",
  "content.kind.product-requirements": "製品要件",
  "content.kind.retrospective": "ふりかえり",
  "content.kind.shared-links": "共有リンク",
  "content.kind.task-report": "タスクレポート",
  "content.type.attachment": "添付ファイル",
  "content.type.blogpost": "ブログ",
  "content.type.page": "ページ",
  "cq.header.title": "質問",
  "create.blog.post.event.description": "ブログ投稿の作成",
  "create.drawer.header": "作成",
  "create.drawer.page.selector.all.pages.in.space": "このスペースのすべてのページ",
  "create.drawer.page.selector.location.header": "場所",
  "create.drawer.page.selector.no.page.found": "ページが見つかりません",
  "create.drawer.page.selector.no.parent.page": "親ページはありません",
  "create.drawer.page.selector.pages.loading": "ページを読み込み中",
  "create.drawer.page.selector.parent.page": "親ページ",
  "create.drawer.page.selector.parent.page.tooltip.help": "ブログ、カレンダー、質問は親ページに表示されません",
  "create.drawer.page.selector.recent.pages": "最近使用したページ",
  "create.drawer.page.selector.select.parent.page": "親ページを選択",
  "create.drawer.space.selector.header": "スペース",
  "create.drawer.space.selector.location.header": "場所",
  "create.drawer.space.selector.no.space.found": "スペースが見つかりません",
  "create.drawer.space.selector.recent.spaces": "最近使用したスペース",
  "create.drawer.space.selector.search.spaces": "すべてのスペース",
  "create.drawer.space.selector.select.a.space": "スペースを選択",
  "create.drawer.space.selector.spaces.loading": "スペースを読み込み中",
  "create.drawer.space.selector.starred.spaces": "スター付きスペース",
  "create.drawer.template.failed.to.load.atlassian.support": "アトラシアン サポートまでご連絡ください。",
  "create.drawer.template.failed.to.load.content": "ページを更新しもう一度試してください。問題が解決しない場合は、",
  "create.drawer.template.failed.to.load.title": "テンプレートを読み込めませんでした",
  "create.name": "作成",
  "css.file": "CSS ファイル",
  "current.space": "現在のスペース",
  "default.space.homepage.title": "{0} ホーム",
  "delete.name": "削除",
  "desc.colourscheme": "この配色について次の色をカスタマイズできます。",
  "description.name": "説明",
  "discard.name": "閉じる",
  "discover.applications": "アプリケーションを発見",
  "draft": "下書き",
  "draft.no.content": "この下書きにはコンテンツが何もありません。",
  "edit.comment": "コメントの編集",
  "edit.labels": "ラベルの追加",
  "editor-help.fabric.help.center.feedback.item": "フィードバック",
  "editor.adf.parsing.error.details": "エラーの詳細:",
  "editor.adf.parsing.error.message.prod": "ページを更新しもう一度試してください。問題が継続する場合は、<a target=\"_blank\" href=\"{link}\">アトラシアン サポート</a>までお問い合わせください。",
  "editor.adf.parsing.error.message.staging": "こちらのチームは既に承知しています。Slack 内の <a target=\"_blank\" href=\"{link}\">#cc-content-experience</a> チャンネルで話してみることもできます。",
  "editor.adf.parsing.error.title.prod": "エディターを読み込めませんでした。",
  "editor.adf.parsing.error.title.staging": "この書類のADFへの変換で問題が発生しました。",
  "editor.attachments": "{0}",
  "editor.attachments.plural": "{0} 添付ファイル",
  "editor.attachments.singular": "{0} 添付ファイル",
  "editor.attachments.zero": "添付ファイル",
  "editor.autocomplete.file.header.text": "提案するファイル",
  "editor.autocomplete.links.create.link": "リンクを挿入してページを作成",
  "editor.autocomplete.links.dialog.search": "‘{0}’ の検索",
  "editor.autocomplete.links.dialog.search.no.text": "検索",
  "editor.autocomplete.links.header.text": "リンク候補",
  "editor.autocomplete.links.web.link": "Webリンクを挿入",
  "editor.autocomplete.macros.dialog.browse": "マクロブラウザを開く",
  "editor.autocomplete.macros.error.load.header": "マクロ情報を取得できませんでした",
  "editor.autocomplete.macros.error.load.retrylink": "再試行",
  "editor.autocomplete.macros.header.text": "マクロ候補",
  "editor.autocomplete.media.files.dialog.browse": "ファイルライブラリを開く",
  "editor.autocomplete.media.header.text": "メディア候補",
  "editor.autocomplete.media.images.dialog.browse": "画像ブラウザを開く",
  "editor.autocomplete.media.macros.dialog.browse": "他のメディアを挿入",
  "editor.autoformat.sampletext.firstcell": "最初のセル",
  "editor.autoformat.sampletext.heading": "見出し",
  "editor.buttons.disable.by.empty.title.tooltip": "公開する前にページにタイトルを付けてください。",
  "editor.buttons.disable.by.not.saving.tooltip": "まだ作業中です...",
  "editor.buttons.disable.by.saving.tooltip": "まだページを保存中です。",
  "editor.cancel.discard.changes.confirmation": "変更を破棄",
  "editor.cancel.discard.changes.message": "入力したすべてのコンテンツが破棄されます。確認してください。",
  "editor.cancel.discard.changes.title": "すべての変更の破棄を確認",
  "editor.cant.publish.changes": "変更を発行できません",
  "editor.change.comment": "何を変更しましたか?",
  "editor.close.publish.tooltip": "公開せずに変更内容を保存する",
  "editor.close.update.tooltip": "更新せずに変更内容を保存する",
  "editor.collab.user.limit.body": "このページは現在多くのユーザーに使用されており、同時に使用できるエディターの最大数に達しています。混みあっていない時に再試行してください。",
  "editor.collab.user.limit.title": "このページは現在編集できません",
  "editor.collaborative-editing.load.error": "エディタを読み込むのに、通常より時間がかかっています。数分お待ちいただいた後、読み込みが終了していない場合はページをリフレッシュしてください。それでもうまくいかない場合は、Confluence管理者にお問い合わせください。",
  "editor.collaborative-editing.refresh-editor.error": "エディターのロード中に問題が発生しました。再度お試しください。",
  "editor.collaborative.mode.disabled": "共同編集は現在オフラインです。編集を続けるためには、作業データをコピーし、ページをリフレッシュしてください。",
  "editor.collaborative.mode.enabled": "共同編集はオフになっていましたが、再びオンになりました。編集を続けるため、変更をコピーしてページをリフレッシュしてください。",
  "editor.content.appearance.toggle.fixed.width": "ページを全幅にします",
  "editor.content.appearance.toggle.full.width": "ページを固定幅にします",
  "editor.content.placeholder.11": "目次や日付、ロードマップなど、素晴らしい情報を何でもこのページに追加できることを知っていましたか? リストを開くには / を入力します。",
  "editor.content.placeholder.ai": "Atlassian Intelligence の場合は「/ai」、要素を追加するには「/」、誰かをメンションするには「@」と入力します(メンションするとそのユーザーに通知されます)。",
  "editor.content.placeholder.bpqa": "「/」と入力すると要素のリストが表示され、「@」と入力するとユーザーにメンションできます。または次の中から選択してください。",
  "editor.content.placeholder.bpqa.ai": "Atlassian Intelligence の場合は「/ai」、要素の場合は「/」、誰かをメンションする場合は「@」と入力します。または、以下から選択することもできます。",
  "editor.content.placeholder.easy.mentions": "「/」と入力するとすべての要素が表示され、「@」と入力するとユーザーにメンションできます。",
  "editor.content.placeholder.slash": "要素を挿入するには「/」を入力します。",
  "editor.content.placeholder.slash.bracket": "「/」を入力すると、簡単に要素を挿入できます",
  "editor.content.reconciliation.error.details": "エラーの詳細:",
  "editor.content.reconciliation.error.fatal.prod": "こちらのチームは既に承知しています。しばらくしてからもう一度試してください。問題が継続する場合は、アトラシアン サポートまでお問い合わせください。",
  "editor.content.reconciliation.error.fatal.staging": "こちらのチームは既に承知しています。Slack 内の #cc-content-experience チャンネルで話してみることもできます。",
  "editor.content.reconciliation.error.retrying": "{0} 秒で再試行...",
  "editor.content.reconciliation.error.title": "このページを読み込めませんでした",
  "editor.content.reconciliation.networkerror.fatal.prod": "ページを更新すると、問題が解決するはずです。問題が解決しない場合は、<a href=\"https://support.atlassian.com/contact/#/\" target=\"_blank\">アトラシアン サポート</a>またはスペース管理者にお問い合わせください。",
  "editor.content.reconciliation.networkerror.title": "コンテンツの読み込み中に問題が発生しました",
  "editor.discard-on-close.tooltip": "空の下書きを破棄する",
  "editor.discard-to-published.button.label": "破棄してください",
  "editor.discard-to-published.button.tooltip": "このページの最後に公開されたバージョンに戻す",
  "editor.discard-to-published.dialog.title": "パブリッシュしていない変更を破棄しますか?",
  "editor.discard-to-published.dialog.warning": "このページの最後に公開されたバージョンに編集作業を戻します。このページで変更を公開していない人がいる場合は、その変更も破棄されます。",
  "editor.discard-to-published.error.message": "現在、このページの最後に公開されたバージョンを取得できません。数分間待った後に下書きの破棄を再度試してください。",
  "editor.discard-to-published.error.title": "最後に公開されたバージョンに戻れません",
  "editor.discard-to-published.success.message": "最後に公開されたバージョンに上手く戻ることができました",
  "editor.draft.can.be.migrated": "共同編集はこちら! このページで作業を続けるには、コンテンツを自分の新しい下書きと結合させる必要があります。<br><a href={0}>今すぐ結合してみましょう。</a>",
  "editor.dynamic-macro.preview.limit.desc": "下書きのダイナミックマクロのプレビューは、共有された下書きが有効な場合に限り完全にサポートされます。",
  "editor.ellipsis.blog.delete": "未公開のブログ投稿を削除する",
  "editor.ellipsis.import-document": "テンプレートを開いて文書をインポート",
  "editor.ellipsis.open.template.browser": "テンプレートブラウザーを開く",
  "editor.ellipsis.open.templates.and.import": "テンプレートと文書のインポート",
  "editor.ellipsis.page.delete": "未公開のページを削除する",
  "editor.ellipsis.remove": "最後に公開したバージョンへ戻る",
  "editor.ellipsis.resolved.comments": "解決したコメント",
  "editor.ellipsis.view-changes": "変更を見る",
  "editor.error.delayed.publishing": "引き続き公開を実行します。時間がかかる場合は、ページを更新して [<strong>公開</strong>] をクリックしてください。",
  "editor.error.delayed.publishing.title": "コンテンツの公開で問題が発生しています。",
  "editor.excerpt.include.macro.error": "\"{0}\" からの抜粋を読み込み中にエラーが発生しました。",
  "editor.excerpt.panel.title.loading": "読み込み中...",
  "editor.fabric.share.invite.to.edit.empty.blog.post.title": "名称未設定のブログ投稿",
  "editor.fabric.share.invite.to.edit.empty.page.title": "名称未設定のページ",
  "editor.fabric.share.invite.to.edit.form.title": "編集に招待",
  "editor.files.may.be.uploading": "一部のファイルはまだアップロード中の可能性があります。1分後に再試行してください。それでも問題が解決しない場合は、ページを更新し、破損していると思われるファイルを発行前に再アップロードしてください。",
  "editor.generic.refresh": "編集機能に何か問題があるようです。編集を続けるには、保存していない変更をコピーして、ページをリフレッシュしてください。",
  "editor.go.back": "戻る",
  "editor.heartbeat.unauthorised.warning.generic.body": "このコンテンツは移動・削除されたか、制限されています。必要な部分をコピーし、エディターを閉じることをお勧めします。",
  "editor.heartbeat.unauthorised.warning.generic.title": "このページへのアクセスはありません",
  "editor.heartbeat.unauthorised.warning.page-move.body": "あなたは、ページの移動または制限の変更のために公開することができません。必要な内容をコピーしてエディターを閉じることをお勧めします。",
  "editor.heartbeat.unauthorised.warning.page-move.title": "ページ権限が変更されています",
  "editor.help.how.to.use.blueprint": "{blueprintType}の使用方法",
  "editor.help.templates": "ページ テンプレートの使用",
  "editor.help.updates": "編集機能の更新",
  "editor.help.updates.1.description": "編集機能の改善の第1段階としてブログ投稿が改善されました。コンテンツの応答性と画像処理が向上し、インターフェースがさらに合理化されています。新しいブログ記事を作成して、お試しください。",
  "editor.help.updates.1.title": "ブログ投稿",
  "editor.help.updates.2.description": "ミーティング議事録に新たな編集機能が加わりました。最新の更新では、テーブルをクリックして切り替えが行える高度テーブル機能が追加されるとともに、スピードと信頼性が向上しました。",
  "editor.help.updates.2.title": "ミーティング議事録",
  "editor.hints.close": "ヒントを閉じる",
  "editor.hints.next": "次のヒント",
  "editor.labels": "{0}",
  "editor.labels.desc": "ページラベルを編集します",
  "editor.labels.plural": "{0} ラベル",
  "editor.labels.singular": "{0} ラベル",
  "editor.labels.zero": "ラベル",
  "editor.learn.more": "詳細",
  "editor.location.desc": "場所の追加",
  "editor.minor.edit": "ウォッチャーに通知",
  "editor.offline.before.save.error": "サーバーと通信できません。現在保存することは不可能です。",
  "editor.offline.preview.error": "サーバーに接続できません。インターネットに接続していること、Confluenceが正常に作動していることを確認してください。",
  "editor.offline.save.error": "サーバと通信できません。 現在保存することができません。",
  "editor.offline.save.error.generic": "リクエストを処理しているときにエラーが発生しました。",
  "editor.offline.save.noauthorized": "セッションの期限が切れました。作業を続けるには、再度ログインするか別のアカウントを使用する必要があります。\n <div><a href=\"/login?application=confluence\">ログインまたは別のアカウントを使用する</a></div>",
  "editor.offline.save.noauthorized.title": "サーバーに接続できません",
  "editor.offline.save.page.exist.content": "「'{'0'}'」というタイトルのページはこのスペースにすでに存在します。このページ用に別のタイトルを入力してください。",
  "editor.onboarding.draft.placeholder": "「/」と入力して、目次やロードマップなど、ページに追加できる便利な要素のリストを表示します。<br/>このページで何を入力したらよいかわからない場合、まずは右のいずれかのテンプレートを使用してください →",
  "editor.onboarding.spotlight.body": "変更点とその理由を確認する。",
  "editor.onboarding.spotlight.finish": "了解",
  "editor.onboarding.spotlight.title": "テンプレートを順次更新しています。",
  "editor.onboarding.step1.content": "あなたが欲しかった機能をご提供しています。先ずは読みやすさの改善、フォーマット・ツールの高性能化、そして外観の改善。<br /><a href=''{linkCAC}' target='_blank'>変更点の詳細をご確認ください</a>",
  "editor.onboarding.step1.title": "フレンドリーなブログ記事",
  "editor.onboarding.step2.content": "一番使われる機能はツールバーにあります。より高度なツールは＋サインの下にあります。あなたの毎日をより楽しくするためにたくさんの新しい絵文字もあります。<br/><a href=''{linkCAC}' target='_blank'>変更点の詳細をご確認ください</a>",
  "editor.onboarding.step2.title": "何かお探しですか?",
  "editor.onboarding.step3.content": "これはまだ作業中です。これを素晴らしいものにするのを手伝ってください。あなたのフィードバックを送ってください、そして<a href=''{linkCAC}' target='_blank'> Confluence ページ</a>をフォローして変化に対しいつもアップデートしていてください。<br/><a href=''{linkCAC}' target='_blank'>変更点の詳細をご確認ください</a>",
  "editor.onboarding.step3.title": "一緒に何かすごいものを作ってみましょう",
  "editor.page.can.not.be.accessed.message": "セッションの期限が切れた可能性があります。作業を続けるには、再度ログインするか別のアカウントを使用する必要があります。\n <div><a href=\"/login?application=confluence\">ログインまたは別のアカウントを使用する</a></div>",
  "editor.page.can.not.be.accessed.title": "このコンテンツにはアクセスできません。",
  "editor.page.conflict.message": "接続の再確立を試行するには、ページを更新してください。",
  "editor.page.conflict.title": "サーバーと同期できません。",
  "editor.page.is.too.big": "このページは大きすぎるため保存できません。複数のページに分割後、<a href=\"https://confluence.atlassian.com/conf51/include-page-macro-336169384.html\" target=\"_blank\">ページマクロを含める</a>を使用してコンテンツを表示してください。",
  "editor.page.is.trashed.message": "コンテンツをコピーして新規ページに追加するか、<div><a href=\"{0}/pages/viewtrash.action?key={1}\" target=\"_blank\">このページをゴミ箱から復元</a>してからもう一度お試しください.</div>",
  "editor.page.is.trashed.title": "このコンテンツは削除されました",
  "editor.page.legacy.draft.deprecated": "共同編集はこちら! これにより、編集セッションを再開するのに、ほとんど手間がかからなくなりました。後はコンテンツをコピーし、このページを再度編集し、それを貼り付けて保存するだけです。",
  "editor.page.moved.message.body": "しかし大丈夫です - あなたの準備ができたら変更箇所を公開することができます。<br /><br /> 新しいロケーション: {0}",
  "editor.page.moved.message.title": "{0}がこのページを移動しました",
  "editor.page.moved.message.unknown.mover": "別のユーザー",
  "editor.placeholder.broken.image": "壊れた画像",
  "editor.placeholder.broken.link": "壊れたリンク",
  "editor.placeholder.broken.macro": "壊れたマクロ",
  "editor.placeholder.error": "エラー",
  "editor.preview.error": "プレビューの読み込み中にエラーが発生しました。後でもう一度やり直してください。",
  "editor.publish.blog": "公開",
  "editor.publish.blog.desc": "公開します",
  "editor.publish.external.share.label": "外部共有",
  "editor.publish.hotkey.description": "このコンテンツを公開するには、キーボードで {keyCombination} を選択します。",
  "editor.publish.with.comment": "バージョン コメント付きで公開...",
  "editor.publish.without.notify": "ウォッチャーに通知することなく公開",
  "editor.quit-dialog.button.delete.blog.exit": "ブログ投稿を削除する",
  "editor.quit-dialog.button.delete.page.exit": "ページを削除する",
  "editor.quit-dialog.button.discard.changes.by.many": "<strong>全員の</strong>変更点を棄てる",
  "editor.quit-dialog.button.discard.changes.by.one": "<strong>全ての</strong>変更を破棄してください",
  "editor.quit-dialog.button.discard.collaborative.tooltip": "未公開の変更をすべて破棄します",
  "editor.quit-dialog.button.discard.limited.tooltip": "共同編集が無効になっています。再び有効にする際には、変更内容を破棄することができます。",
  "editor.quit-dialog.button.revert.blog.exit": "ブログ投稿を元に戻す",
  "editor.quit-dialog.button.revert.page.exit": "ページを元に戻す",
  "editor.quit-dialog.button.save.exit": "ドラフトを保持してください",
  "editor.quit-dialog.cancel.changes.by.many": "<p>あなたや他の人による変更のうち、まだ公開されていないものがあります。</p> <p>変更を棄てると、次の人たちが加えた変更も削除することになり、このページが最後に公開された時のバージョンに戻ります。そうすると、彼らの仕事を復元することはできなくなります。</p> <p>変更を加えたのは次の人たちです:</p>",
  "editor.quit-dialog.cancel.changes.by.one": "<p>あなたの変更はまだ公開されていません。</p> <p>もし変更を棄てると、未公開の変更が削除されます。このアクションは取り消しできません。</p>",
  "editor.quit-dialog.delete.blogpost.changes.by.many": "これをするとあなたと他の人達が作業をして来たブログ記事が完全に消去されます。",
  "editor.quit-dialog.delete.blogpost.changes.by.one": "未公開のブログ投稿を一旦削除したら、元に戻すことはできません。",
  "editor.quit-dialog.delete.page.changes.by.many": "これにより、あなたやこれらの他の人々が作業したページが永久に削除されます",
  "editor.quit-dialog.delete.page.changes.by.one": "未公開のページを削除したら、元に戻すことはできません。",
  "editor.quit-dialog.last.edited": "最後に編集",
  "editor.quit-dialog.link.hide.diff": "変更を隠してください",
  "editor.quit-dialog.link.show.diff": "変更を表示してください",
  "editor.quit-dialog.publish.changes": "<p>あなたや他の人による変更のうち、まだ公開されていないものがあります。</p><p>この人たちが変更を加えました:</p>",
  "editor.quit-dialog.revert.blogpost.changes.by.one": "これにより、最後にこのブログ投稿が公開されてから加えた変更が全て永久に削除されます",
  "editor.quit-dialog.revert.changes.by.many": "これにより、最後にこのページが公開されてから次の人々が加えた変更が全て永久に削除されます",
  "editor.quit-dialog.revert.page.changes.by.one": "これにより、最後にこのページが公開されてから加えた変更が全て永久に削除されます。",
  "editor.quit-dialog.title.blogpost.delete": "未公開のブログ投稿を削除しますか?",
  "editor.quit-dialog.title.discard": "最後に公開されたバージョンに戻しますか?",
  "editor.quit-dialog.title.exit": "エディターを閉じてください",
  "editor.quit-dialog.title.page.delete": "未公開のページを削除しますか?",
  "editor.quit-dialog.title.publish": "変更を全てパブリッシュしますか?",
  "editor.restrictions.desc": "ページ制限を編集します",
  "editor.return.to.edit": "編集モードに戻る",
  "editor.satisfaction.survey.description": "編集を行った感想をお聞かせください。",
  "editor.satisfaction.survey.final.description": "あなたのフィードバックが送信されました",
  "editor.satisfaction.survey.final.title": "ありがとうございます",
  "editor.satisfaction.survey.question.bad": "大変申し訳ございませんでした。問題の内容をご説明ください。(オプション)",
  "editor.satisfaction.survey.question.good": "ありがとうございました気に入った点をお聞かせください。改善が必要な点はどこでしょうか。(オプション)",
  "editor.satisfaction.survey.title": "あなたのページが公開されました",
  "editor.save.draft.desc": "下書きを保存します",
  "editor.save.page.desc": "保存",
  "editor.shared.draft.done.desc": "下書きを保存します。空の場合は破棄します。",
  "editor.shared.draft.publish.desc": "変更を公開",
  "editor.shared.draft.update.desc": "パブリッシュ (公開) 済みのページを更新",
  "editor.shortcuts": "キーボードのショートカットの編集",
  "editor.synchrony.publish-page.message": "{0}がこのページを公開しました。",
  "editor.template.changing.variable.dialog.title": "テンプレート変数を編集",
  "editor.template.variable.input.creation.error.action": "アトラシアン サポートへのお問い合わせ",
  "editor.template.variable.input.creation.error.description": "ページを更新してもう一度やり直してください。問題が解決しない場合は以下のリンクからご連絡ください。",
  "editor.template.variable.input.creation.error.title": "エラーが発生しました",
  "editor.template.variable.list.field.placeholder": "オプション1, オプション2, オプション3",
  "editor.template.variable.name.field": "変数名",
  "editor.title.is.empty": "パブリッシュを押す前にページタイトルを加えてください。",
  "editor.title.is.empty.title": "このページは名前が必要です。",
  "editor.title.placeholder": "ページタイトル",
  "editor.title.too.long": "タイトルは 255 文字以下にしてください。",
  "editor.unavailable.generic.body": "編集は現在利用できません。数分後に再試行してください。",
  "editor.unavailable.title": "編集できません",
  "editor.unpublished.changes.lozenge.label": "未発行",
  "editor.unpublished.changes.lozenge.tooltip": "このページには未発行の変更があります",
  "editor.waiting.to.publish.changes": "まだファイルをアップロードしている可能性があります。",
  "editor.waiting.to.publish.changes.title": "しばらくお待ちください、少し時間がかかっています。",
  "email.text.added.by": "追加 :",
  "error.connection.lost.body": "再接続されるまで、こちらで待機します。",
  "error.connection.lost.title": "接続が切れたようです。",
  "error.connection.recovered.action": "コンテンツをリロードする",
  "error.connection.recovered.title": "再接続",
  "error.notfound.title": "ページを見つけることができません。",
  "error.recovery.body": "変更は保存されていますのでご安心ください。ページを更新してもう一度お試しください。",
  "error.recovery.title": "エディターの読み込み中に問題が発生しました",
  "error.server-error.body": "後ほど、再度お試しください。",
  "error.server-error.title": "何か問題が発生しています。",
  "error.session.expired.body": "次は必ずしっかりやります、お約束します。",
  "error.session.expired.title": "セッションが切れたようです。",
  "excel.file": "Microsoft Excel スプレッドシート",
  "excel.macro.file": "Microsoft Excel マクロ対応スプレッドシート",
  "excel.template.file": "Microsoft Excel テンプレート",
  "excel97.file": "Microsoft Excel シート",
  "excel97.template.file": "Microsoft Excel 97 テンプレート",
  "existing.blogpost.placeholder": "ブログ投稿タイトル",
  "expand-macro.default-title": "ここをクリックすると展開されます...",
  "expand.name": "展開",
  "fabric.editor.announcement.datednotice.main": "{0} より、新しい編集体験が可能になります。",
  "fabric.editor.announcement.dismiss": "閉じる",
  "fabric.editor.announcement.greeting": "{0}様",
  "fabric.editor.announcement.initialnotice.main": "近々、Confluence でコンテンツを作成する方法が変わります。",
  "fabric.editor.announcement.link.action": "変更点や新機能の数々をご確認ください。",
  "fabric.editor.announcement.rollbacknotice.action": "現在のページを旧エクスペリエンスに戻す方法について、お知らせをご確認ください。",
  "fabric.editor.announcement.rollbacknotice.main": "先日、あなたのページは新しい編集エクスペリエンスに意図せず更新されましたが、現在は元に戻っています。",
  "fabric.editor.announcement.tryit.action": "新しいページで試す",
  "fabric.editor.announcement.tryitnotice.main": "ページが見やすくなり、ライブ マクロなどの新機能をご利用いただける新しい編集体験をお試しください。",
  "fabric.editor.changeboarding.banner.action": "新機能をご覧ください。",
  "fabric.editor.changeboarding.banner.dismiss": "閉じる",
  "fabric.editor.changeboarding.banner.main": "{0} さん、こんにちは。私たちは、より見た目が良く、読みやすいコンテンツを作成しやすくなるように更新を行っています。",
  "fabric.editor.page.removed.description": "今すぐ更新してください。",
  "fabric.editor.page.removed.title": "このページは最近アーカイブまたは削除されました",
  "fabric.editor.permission.removed.description": "このページの権限は変更されています。管理者にお問い合わせください。",
  "fabric.editor.permission.removed.title": "このページを表示できません",
  "fabric.full.width.help.center.dialog.title": "新機能! 幅の調整",
  "fabric.full.width.help.center.pageElement.details": "<p><strong>すべてのページ要素</strong>を水平方向に拡張して、空白のスペースを減らします。切り替えによってページのコンテンツを固定幅に戻せます。</p>",
  "fabric.full.width.help.center.pageElement.title": "全幅のページの切り替え",
  "fabric.full.width.help.center.tableElement.details": "<p>幅広や全幅のオプションを使用して、<strong>各列、テーブル、</strong>ほとんどの<strong>マクロ</strong>の幅を管理できます。特定の要素を固定幅のままにできます。</p>",
  "fabric.full.width.help.center.tableElement.title": "個別要素の切り替え",
  "fabric.help.center.columns.details": "<p>ページに<strong>列</strong>を追加し、<strong>フローティングメニュー</strong>を使用して2〜3の列設定の間で切り替えます。</p>",
  "fabric.help.center.columns.title": "列",
  "fabric.help.center.dialog.title": "基本を学ぶ",
  "fabric.help.center.imageDisplay.details": "<p>画像を選択し、<strong>ハンドル</strong>をドラッグしてサイズを調節し、<strong>フローティング メニュー</strong>を使用して配列を変えます。</p>",
  "fabric.help.center.imageDisplay.title": "画像表示",
  "fabric.help.center.layouts.details": "<p> <kbd>←</kbd> <kbd>→</kbd>を使って列、表、そしてマクロのレイアウトを変更します。</p><p>スクリーン間で幅が変わらない<strong>固定幅</strong>と、スペースいっぱいに拡張する</strong>全幅</strong>、そしてその中間の<strong>幅広</strong>設定から選択します。</p>",
  "fabric.help.center.layouts.title": "レイアウト",
  "fabric.help.center.menuitem.title": "チュートリアル",
  "fabric.help.center.slashCommands.details": "<p><kbd>/</kbd>と入力してメニューを開き、<strong>表</strong>、<strong>マクロ</strong>、<strong>日付</strong>などのコンテンツをページに随時挿入します。</p>",
  "fabric.help.center.slashCommands.title": "スラッシュコマンド",
  "fabric.help.center.spotlight.body": "ここからいつでもチュートリアルを復習できます。",
  "fabric.help.center.spotlight.header": "復習が必要ですか?",
  "fabric.help.center.tableManipulation.details": "<p><strong>表の枠線</strong>、<strong>ドロップダウン</strong>および<strong>フローティングメニュー</strong>から表を編集またはフォーマットします。</p>",
  "fabric.help.center.tableManipulation.title": "表の操作",
  "fabric.help.center.templates.details": "<p>ニーズに合ったテンプレートが見つかります。パネルを閉じた場合は、その他のアクション (•••) メニューからパネルを再度開くことができます。</p>",
  "fabric.help.center.templates.title": "テンプレート",
  "fabric.help.center.title": "基本を学ぶ",
  "fabric.insert.external.image": "ウェブから画像を挿入",
  "fabric.template.can.not.parse.content": "このテンプレートには壊れている要素または対応していない要素が含まれるため開けません。",
  "fabric.template.can.not.save.error.title": "変更を保存できません",
  "fabric.template.can.not.save.error.title.duplicate": " すでに <strong>{0}</strong> というテンプレートが存在します。テンプレートに別のタイトルを付けて保存してください。",
  "fabric.template.found.invalid.node": "「{variableNames}」という同一の名前を持ちながらパラメータが異なる複数のテンプレート変数があります。",
  "favourite.spaces": "マイ スペース",
  "feedback.flag.thanks.description": "フィードバックは今後の品質向上のために活用させていただきます。",
  "feedback.flag.thanks.title": "ありがとうございました",
  "filter.name": "フィルター",
  "gif.file": "GIF ファイル",
  "global.spaces": "サイト スペース",
  "globaladminbilling.label": "請求",
  "header.or.footer.unsupported.macros.list": "次のマクロは{0}では現在サポートされていません:",
  "header.or.footer.unsupported.macros.title": "サポートされていないマクロ",
  "heading.comment": "変更者",
  "heading.createpage": "ページの作成",
  "heading.createpage.sentence": "ページの作成",
  "heading.operations": "操作",
  "heading.version.date": "パブリッシュされました",
  "heading.version.number": "バージョン",
  "help.name": "ヘルプ",
  "help.us.improve": "改善にご協力ください",
  "hipchat.presence.status.available": "オンライン",
  "hipchat.presence.status.away": "退席中",
  "hipchat.presence.status.dnd": "取り込み中",
  "hipchat.presence.status.offline": "オフライン",
  "html.file": "HTML ファイル",
  "icon.tooltip.remove": "取り除く",
  "icon.tooltip.undo": "元に戻す",
  "image.browser.imageurl.label": "画像 URL",
  "image.height": "高さ",
  "image.properties.dialog.cancel": "キャンセル",
  "image.properties.dialog.heading": "画像プロパティ",
  "image.properties.trigger": "プロパティ",
  "image.properties.trigger.tooltip": "追加する画像プロパティの設定",
  "inline.comment.sidebar.navigate.next.description": "次のインラインコメントです",
  "inline.comment.sidebar.navigate.previous.description": "以前のインラインコメントです",
  "inline.comments.GROW-1507.dialog.close.label": "閉じる",
  "inline.comments.GROW-1507.dialog.content": "インライン コメントをご存知ですか?<br>レビューしたり、ドキュメントの特定の場所に追加したりして使用できます。",
  "inline.comments.GROW-1507.dialog.header": "インラインコメント",
  "inline.comments.GROW-1507.dialog.ok.label": "了解",
  "inline.comments.GROW-1507.dialog.showme.label": "表示する",
  "inline.comments.GROW-1507.dialog.title": "コメントについてのヒント",
  "inline.comments.batch.email.view": "コメントを表示",
  "inline.comments.create.placeholder": "コメントを入力…",
  "inline.comments.create.reply.placeholder": "返信",
  "inline.comments.date.friendly.about.one.hour.ago": "1時間前",
  "inline.comments.date.friendly.about.x.days.ago": "{0} 日前",
  "inline.comments.date.friendly.about.x.hours.ago": "{0} 時間前",
  "inline.comments.date.friendly.formatted": "{0}",
  "inline.comments.date.friendly.now": "今",
  "inline.comments.date.friendly.one.min.ago": "1分前",
  "inline.comments.date.friendly.x.mins.ago": "{0, plural, other {{0} 分前}}",
  "inline.comments.date.friendly.yesterday": "昨日",
  "inline.comments.delete.confirmation.message": "このコメントを削除してもよろしいですか?",
  "inline.comments.delete.permission": "このコメントを削除する権限がありません。",
  "inline.comments.delete.reply.confirmation.message": "この返信を削除してもよろしいですか?",
  "inline.comments.delete.with.reply": "返信のあるインラインコメントのスレッドは削除できません。",
  "inline.comments.delete.with.reply.need.reload": "このスレッドに新しい返信があるため、このコメントは削除できません。表示するには再度読み込んでください。",
  "inline.comments.edit.permission": "このコメントを編集する権限がありません。",
  "inline.comments.editor.lost": "コメントは失われます。",
  "inline.comments.editor.timeout": "エディターが正しく読み込まれませんでした。再試行するには{0}ページを再読み込み{1}してください。",
  "inline.comments.expand.replies": "さらに{0}件の返信",
  "inline.comments.fabric.editor.error.cannot.be.empty": "コメントが空です。フィードバックを追加し、[保存] をクリックしてください。",
  "inline.comments.fabric.editor.error.captcha.check.failed": "キャプチャのチェックに失敗しました",
  "inline.comments.fabric.editor.error.captcha.check.succeeded": "キャプチャのチェックに成功しました",
  "inline.comments.fabric.editor.error.create.not.permitted": "権限の設定により、コメントを作成することができません。この機能が必要な場合、管理者に確認してください。",
  "inline.comments.fabric.editor.error.delete.not.permitted": "権限の設定により、コメントを削除することができません。この機能が必要な場合、管理者に確認してください。",
  "inline.comments.fabric.editor.error.edit.not.permitted": "権限の設定により、コメントを編集することができません。この機能が必要な場合、管理者に確認してください。",
  "inline.comments.fabric.editor.error.invalid.selection": "コメントを作成できません。他と明確に区別できるテキストを選択してハイライトし、コメントが適切なコンテンツにマッピングされるようにしてください。",
  "inline.comments.fabric.editor.error.resolve.not.permitted": "権限の設定により、コメントを解決することができません。この機能が必要な場合、管理者に確認してください。",
  "inline.comments.fabric.editor.error.unexpected": "このコメントの保存中にエラーが発生しました。コメントを閉じるかページを再読み込みし、再度コメントを追加してみてください。",
  "inline.comments.fabric.editor.error.view.not.permitted": "権限の設定により、コメントを表示することができません。この機能が必要な場合、管理者に確認してください。",
  "inline.comments.fabric.inline.button.cancel": "キャンセル",
  "inline.comments.fabric.inline.button.save": "保存",
  "inline.comments.fabric.sidebar.loading.error": "エラーが発生しました。コメントのウィンドウを閉じて、もう一度お試しください。",
  "inline.comments.likes.error": "「いいね!」は更新できません。",
  "inline.comments.likes.like": "いいね!",
  "inline.comments.likes.unlike": "いいね! を取り消す",
  "inline.comments.navigation.index.of": "{1}件中{0}件",
  "inline.comments.notification.email.reopened": "再オープンされました",
  "inline.comments.notification.email.resolved": "解決済",
  "inline.comments.notification.email.view": "コメントを表示",
  "inline.comments.resolve.permission": "このコメントを解決する権限がありません。",
  "inline.comments.resolved.dangling.message": "テキストは{1}に{0}さんにより削除されたため、解決されました",
  "inline.comments.resolved.dialog.empty": "このページには解決済みのコメントはありません。",
  "inline.comments.resolved.dialog.message": "このコメントは永久に失われるわけではありません！解決済みのコメントはいつでも表示できます。",
  "inline.comments.resolved.dialog.show.me": "表示する",
  "inline.comments.resolved.discovery.button.dismiss": "了解",
  "inline.comments.resolved.discovery.content": "さらにご意見をお持ちですか? 解決済みのコメントを再オープンしてディスカッションを続けられます。",
  "inline.comments.resolved.menu.show.replies": "{0}件の返信",
  "inline.comments.resolved.menu.show.reply": "{0}件の返信",
  "inline.comments.resolved.menu.unresolve": "再オープン",
  "inline.comments.resolved.message": "{1}に{0}さんにより解決されました",
  "inline.comments.resolved.view.menu": "解決済みコメント",
  "inline.comments.server.edit.error": "編集を保存できません。コメントは削除された可能性があります。",
  "inline.comments.server.error": "リクエストを完了できませんでした。",
  "inline.comments.server.error.edit.comment": "このコメントを編集できません。コメントは削除された可能性があります。",
  "inline.comments.server.error.edit.reply": "この返信を編集できません。返信は削除された可能性があります。",
  "inline.comments.sidebar.cancel": "取消",
  "inline.comments.sidebar.close": "閉じる",
  "inline.comments.sidebar.comment.empty": "空のコメントは保存できません。",
  "inline.comments.sidebar.delete": "削除",
  "inline.comments.sidebar.deleted": "削除済み",
  "inline.comments.sidebar.discard": "破棄",
  "inline.comments.sidebar.edit": "編集",
  "inline.comments.sidebar.error.create.comment": "インラインコメントを追加できません。ハイライトされたセクションにマクロかユーザーのメンションが含まれている可能性があります。プレーンテキストをハイライトしてください。",
  "inline.comments.sidebar.error.delete.generic": "コメントの削除中にエラーが発生しました。Confluenceログでエラーを確認してください。",
  "inline.comments.sidebar.error.delete.unauthorised": "このコメントを削除する権限がありません。",
  "inline.comments.sidebar.error.empty": "コメントを入力してください。",
  "inline.comments.sidebar.error.save.comment": "コメントを保存できませんでした",
  "inline.comments.sidebar.error.save.reply": "返信を保存できませんでした",
  "inline.comments.sidebar.error.stale": "ページのコンテンツが最新ではありません。{0}更新{1}して再試行してください。",
  "inline.comments.sidebar.like": "いいね!",
  "inline.comments.sidebar.pagecomment.success": "ページコメントが作成されました",
  "inline.comments.sidebar.reply": "返信",
  "inline.comments.sidebar.resolve": "解決",
  "inline.comments.sidebar.resolved": "解決済",
  "inline.comments.sidebar.save": "保存",
  "inline.comments.sidebar.saved": "保存済",
  "inline.comments.sidebar.shortcuts.close.description": "インラインコメントを閉じる",
  "inline.comments.sidebar.show.resolved.comment": "解決したコメントを表示",
  "inline.comments.sidebar.tooltip.close.description": "サイドバーを閉じます ( ] )",
  "inline.comments.sidebar.tooltip.next.ic.description": "次のコメント (N)",
  "inline.comments.sidebar.tooltip.previous.ic.description": "前のコメント (P)",
  "inline.comments.templates.create.a.comment": "さんがページに<strong>コメントしました</strong>",
  "inline.comments.templates.resolved.a.comment": "さんがコメントを<strong>解決しました</strong>",
  "inline.comments.templates.resolved.a.comment.dangling": "さんがインラインコメントで参照されたテキストを削除したので、コメントは<strong>解決されました</strong>",
  "inline.comments.templates.unresolved.a.comment": "さんがコメントを<strong>再オープンしました</strong>",
  "inline.comments.unresolved.message": "{1}に{0}さんにより再オープンされました",
  "jar.file": "Javaアーカイブ",
  "java.file": "Java ソース",
  "jpeg.file": "JPEG ファイル",
  "js.file": "JavaScript ファイル",
  "keyboard.shortcut.alt": "Alt",
  "keyboard.shortcut.ctrl": "Ctrl",
  "keyboard.shortcut.option": "オプション",
  "keyboard.shortcut.shift": "Shift",
  "label.contains.invalid.chars": "<b>{0}</b> に無効な文字 ({1}) が含まれています。",
  "label.name.is.too.long": "ラベル名は {0} 文字未満でなければなりません。",
  "labels.dialog.shortcut.tip": "ショートカット ヒント: ページ ビューで<b>{shortcut}</b>を押すと、このダイアログも開きます",
  "labels.none": "ラベルがありません",
  "labels.title": "ラベル",
  "last.saved": "最終保存日",
  "likes.bethefirst": "これに いいね! をつける",
  "likes.follow": "注目",
  "likes.following": "注目しています",
  "likes.like": "いいね!",
  "likes.peoplewholikethis": "いいね! しているユーザー",
  "likes.summary.1.non-promoted": "{0} がいいね!しています",
  "likes.summary.1.promoted": "{0} がいいね! しています",
  "likes.summary.1.promoted.1.non-promoted": "{0} と {1} がいいね! しています",
  "likes.summary.2.promoted": "{0} と {1} がいいね! しています",
  "likes.summary.2.promoted.1.non-promoted": "{0}、{1} および {2} がいいね! しています",
  "likes.summary.3.promoted": "{0}、{1} および {2} がいいね! しています",
  "likes.summary.3.promoted.1.non-promoted": "{0}、{1}、{2} および {3} がいいね! しています",
  "likes.summary.you": "いいね! しています",
  "likes.summary.you.1.non-promoted": "あなたと {0} がいいね! しています",
  "likes.summary.you.1.promoted": "あなたと {0} がいいね! しています",
  "likes.summary.you.1.promoted.1.non-promoted": "あなた、{0} および {1} がいいね! しています",
  "likes.summary.you.2.promoted": "あなた、{0} および {1} がいいね! しています",
  "likes.summary.you.2.promoted.1.non-promoted": "あなた、{0}、{1} および {2} がいいね! しています",
  "likes.summary.you.3.promoted": "あなた、{0}、{1} および {2} がいいね! しています",
  "likes.summary.you.3.promoted.1.non-promoted": "あなた、{0}、{1}、{2} および {3} がいいね! しています",
  "likes.unlike": "いいね! を取り消す",
  "limited.mode.existing.editor.body": "共同編集は現在オフラインで、{0}がこのページを編集しています。数分後にもう一度試してください。",
  "link.browser.advanced.desc1": "新しいページへのリンクを挿入するには、目的のページのタイトルを入力します。",
  "link.browser.advanced.desc2": "アンカー リンクを挿入するには、#アンカー名を入力します。",
  "link.browser.advanced.error.internal.error": "内部サーバー エラーが発生しました",
  "link.browser.advanced.error.not.link": "指定したマークアップは有効なリンク マークアップではありません",
  "link.browser.advanced.error.unknown.shortcut": "{0} をショートカットとして認識できません",
  "link.browser.advanced.error.unknown.space": "{0} をスペースとして認識できません",
  "link.browser.advanced.title": "こちらでは<a href=\"{0}\" target=\"_blank\">Wikiマークアップ</a>を使用してページにリンクを挿入できます。",
  "link.browser.autocomplete.hint": "使い方のヒント: エディターに\"[\"と入力すると、おすすめのページの一覧が表示でき、リンクを挿入できます。",
  "link.browser.cancel.button": "キャンセル",
  "link.browser.edit.button": "挿入",
  "link.browser.edit.title": "リンクの編集",
  "link.browser.file.attach": "アップロードするファイル",
  "link.browser.file.attach.desc": "このページに添付されたファイルへのリンク作成、もしくはファイルを新たに添付します。",
  "link.browser.file.attach.upload.in.progress": "アップロード中...",
  "link.browser.file.browse.button": "参照",
  "link.browser.files.none": "このページにはファイルはありません。",
  "link.browser.insert.button": "挿入",
  "link.browser.insert.title": "リンクの挿入",
  "link.browser.link": "リンク",
  "link.browser.link.alias": "リンクテキスト",
  "link.browser.link.image.label": "画像のリンク",
  "link.browser.location": "リンクの場所",
  "link.browser.recently.viewed.load.error": "最近表示したページの読み込み中にエラーが発生しました。",
  "link.browser.recently.viewed.none": "最近表示したコンテンツはありません。",
  "link.browser.search": "検索",
  "link.browser.search.for": "検索対象",
  "link.browser.search.invalid": "無効な検索条件を指定しました。",
  "link.browser.search.results.load.error": "検索の際にエラーが発生しました。",
  "link.browser.search.results.none": "何も見つかりませんでした。",
  "link.browser.space.all": "すべてのコンテンツ",
  "link.browser.tab.name.advanced": "詳細",
  "link.browser.tab.name.files": "ファイル",
  "link.browser.tab.name.recently.viewed": "最近の表示",
  "link.browser.tab.name.search": "検索",
  "link.browser.tab.name.weblinks": "Webリンク",
  "link.browser.table.file.comment": "コメント",
  "link.browser.table.file.name": "名前",
  "link.browser.table.file.size": "サイズ",
  "link.browser.table.last.modified": "最終更新日",
  "link.browser.table.space": "スペース",
  "link.browser.table.title": "タイトル",
  "link.browser.web.link": "URL",
  "link.browser.web.link.desc": "Web、電子メールまたはその他のインターネット アドレス",
  "link.browser.web.link.label": "アドレス",
  "location.name": "場所",
  "login.button": "ログイン",
  "look.and.feel": "ルック アンド フィール",
  "marketplace.link.name": "Marketplace アプリ",
  "more.word.action": "その他の操作",
  "more.word.capitalised": "表示数を増やす",
  "moveblogpost.already.exists.in.target.space": "選択されたスペースには同一のタイトルと日付がある別のブログ投稿が既に存在します。",
  "moveblogpost.source.notfound": "ソースのブログ投稿が見つかりませんでした。",
  "moveblogpost.target.space.notfound": "ターゲットスペースは見つかりませんでした。",
  "moveblogpost.target.space.same.as.origin": "ブログ投稿を既にあるスペースに移動させることはできません。",
  "multimedia.file": "マルチメディア ファイル",
  "my.drafts.mainBanner": "アイディアをすばやくキャプチャ",
  "my.drafts.subBanner": "ページを作成してアイディアを書き留めましょう。公開する準備が整っていなければ、ページを閉じます。ドラフトとして自動保存され、またいつでも作業を開始できます。 ",
  "my.spaces.tooltip.add": "マイ スペースに追加",
  "my.spaces.tooltip.remove": "マイ スペースから削除",
  "name.word": "名前",
  "nav.controller.activity": "アクティビティ",
  "nav.controller.activity.feed": "アクティビティ フィード",
  "nav.controller.all.spaces": "スペース",
  "nav.controller.discover": "発見しよう",
  "nav.controller.my.spaces": "マイ スペース",
  "nav.controller.my.spaces.anchor": "すべて",
  "nav.controller.my.spaces.blank": "最も多く利用するスペースをマイ スペースに登録しましょう。各スペースのスター アイコンをクリックすると、ここにそのスペースが表示されます。",
  "nav.controller.my.spaces.blank.callToAction": "スペースを見つけましょう",
  "nav.controller.projects": "プロジェクト",
  "nav.controller.recent": "最近表示したページ",
  "nav.controller.your.work": "あなたの作業",
  "navigation.app.switcher.apps": "アプリ",
  "navigation.app.switcher.dont.show.again": "今後は表示しない",
  "navigation.app.switcher.edit": "編集",
  "navigation.app.switcher.error-message": "アプリケーションリンクのエラー",
  "navigation.app.switcher.home.description": "ホーム",
  "navigation.app.switcher.img.alt": "アプリケーションスイッチャー",
  "navigation.app.switcher.loading": "ロード中...",
  "navigation.app.switcher.recent": "最近",
  "navigation.app.switcher.recent-containers-confluence-space": "スペース",
  "navigation.app.switcher.recent-containers-jira-project": "プロジェクト",
  "navigation.app.switcher.try.other.apps": "他のアプリを試す",
  "navigation.app.switcher.use.confluence": "Confluenceを使う",
  "navigation.app.switcher.use.jira": "Jiraを使う",
  "navigation.label-for-bell": "通知",
  "navigation.label-for-global-people-icon": "ユーザー ディレクトリ",
  "navigation.notification-drawer-title": "ホーム通知",
  "navigation.people-drawer-title": "ユーザー ディレクトリ",
  "navlink.edit": "編集({0}E{1})",
  "network.page": "ネットワーク ページ",
  "no.drafts.found": "下書きが見つかりません。",
  "no.matches.mainBanner": "お探しの物が見つかりません",
  "no.name": "いいえ",
  "no.permission": "権限がありません",
  "no.spaces.found": "スペースが見つかりません。",
  "not.watching.anything": "ウォッチしているコンテンツはありません。",
  "notification.start": "ウォッチの開始",
  "notification.stop": "ウォッチの中止",
  "notifications.batch.inline.comment.created.section.header": "{0, choice, 1#インライン コメント|1<インライン コメント}",
  "notifications.batch.inline.comment.new.lozenge": "新規",
  "notifications.batch.inline.comment.reopened.lozenge": "再オープンしました",
  "notifications.batch.inline.comment.resolved": "$userがコメントを$lozenge",
  "notifications.batch.inline.comment.resolved.lozenge": "解決しました",
  "notifications.preferences.desc": "メール通知オプションの設定は<a href=\"viewmyemailsettings.action\">メール設定</a>ページで変更できます。",
  "onboarding-choose-a-space.description": "チームの現在のスペースから 1 つ選択します。スペースは後でさらに作成できます。",
  "onboarding-choose-a-space.title": "作業するスペースを選択",
  "onboarding.choose-a-space.backBtn": "戻る",
  "onboarding.choose-a-space.nextBtn": "次へ",
  "onboarding.choose-a-space.selectLabel": "スペース名",
  "onboarding.choose-a-space.selectPlaceholder": "スペース名を選択",
  "onboarding.create-a-space.backBtn": "戻る",
  "onboarding.create-a-space.description": "まずは、チームやプロジェクト向けの 1 つのスペースから始めます。スペースは後でさらに作成できます。",
  "onboarding.create-a-space.inputTextLabel": "名前",
  "onboarding.create-a-space.inputTextPlaceholder": "Crystal gems",
  "onboarding.create-a-space.invalidMessage": "スペース名には英数字を 1 字以上使用する必要があります。",
  "onboarding.create-a-space.nextBtn": "次へ",
  "onboarding.create-a-space.title": "作業するスペースを作成",
  "onboarding.dialog.existing-user.cancel": "ヒントを非表示",
  "onboarding.dialog.existing-user.confirm": "さあ始めましょう",
  "onboarding.dialog.existing-user.content": "ダッシュボードをさらに使い良くするため、模様替えをしました。さらに、使い始めるに当たって役立つヒントもご覧ください。",
  "onboarding.dialog.existing-user.title": "生まれ変わったダッシュボードへようこそ!",
  "onboarding.dialog.new-user.cancel": "ヒントを非表示",
  "onboarding.dialog.new-user.confirm": "さあ始めましょう",
  "onboarding.dialog.new-user.content": "ダッシュボードは、Confluenceの各機能に移動するためのランディングページです。<br/>使い始めるに当たって役立つヒントをご覧ください。",
  "onboarding.dialog.new-user.title": "ダッシュボードへようこそ!",
  "onboarding.navigation.blog.tip.blog.list.byline": "ページのリストや他のコンテンツに切り替えるには、ホームをクリックします。",
  "onboarding.navigation.blog.tip.blog.list.heading": "あなたのブログのリストはまだここで見ることができます",
  "onboarding.navigation.dont.show": "これ以上TIPSを表示しない",
  "onboarding.navigation.global.sidebar.byline": "これでコンフルエンスのどこにいるときでも、重要なものにたった1クリックでたどり着けます。",
  "onboarding.navigation.global.sidebar.heading": "このサイドバーは共通になりました",
  "onboarding.navigation.ok": "OK、分かりました",
  "onboarding.navigation.page.tip.page.tree.byline": "ブログのリストや他のコンテンツに切り替えるには、ホームをクリックします。",
  "onboarding.navigation.page.tip.page.tree.heading": "あなたのページツリーはまだここで見ることができます",
  "onboarding.navigation.space.tip.space.tabs.byline": "あなたのスペースのホームページが概要表示され、ページ、ブログの投稿、その他のコンテンツがそれぞれ専用のタブで表示されるようになりました。",
  "onboarding.navigation.space.tip.space.tabs.heading": "コンテンツがタブで整理されました",
  "onboarding.tooltip.actions.done": "分かりました！",
  "onboarding.tooltip.actions.next": "次へ",
  "onboarding.tooltip.actions.skip": "ヒントをスキップする",
  "onboarding.tooltip.existing-user.favourite-spaces.content": "お気に入りのスペース直接行くか、全てのスペースのリストに行きましょう。",
  "onboarding.tooltip.existing-user.favourite-spaces.title": "指一本でお気に入りのスペースへ",
  "onboarding.tooltip.existing-user.sidebar.content": "サイドバーから新しいページを見つけたり、最近の作業に戻ったりできます。",
  "onboarding.tooltip.existing-user.sidebar.title": "サイドバーでさらなる発見を",
  "onboarding.tooltip.new-user.favourite-spaces.content": "お気に入りのスペースに直接行くか、全てのスペースのリストに行きましょう。",
  "onboarding.tooltip.new-user.favourite-spaces.title": "指一本でお気に入りのスペースへ",
  "onboarding.tooltip.new-user.sidebar.content": "サイドバーから新しいページを見つけたり、最近の作業に戻ったりできます。",
  "onboarding.tooltip.new-user.sidebar.title": "サイドバーでさらなる発見を",
  "onboarding.tooltip.saved-for-later.content": "お気に入りページは現在新しい名前の下に表示されています - 後で読む",
  "onboarding.tooltip.saved-for-later.title": "さようなら「お気に入り」、こんにちは「後で読む」",
  "onboarding.who-is-on-your-team.addMoreBtn": "+ さらにメールアドレスを追加",
  "onboarding.who-is-on-your-team.description": "Confluenceは、一緒に作業を作成しディスカッションを重ねてコラボレーションするチームメイトと共に使用すると、最大の効果を発揮します。",
  "onboarding.who-is-on-your-team.emailPlaceholder": "メールアドレスを追加",
  "onboarding.who-is-on-your-team.enableDRS": "確認済みの {domain} メールアドレスを持つ人ならだれでもあなたのサイトに参加できるようにする (誰かが参加するたびに通知を受信します)。",
  "onboarding.who-is-on-your-team.enableOpenInvite": "すべてのユーザーが他のユーザーをあなたのサイトに招待できます。",
  "onboarding.who-is-on-your-team.form.invalid.email": "有効なメールアドレスを入力してください",
  "onboarding.who-is-on-your-team.nextBtn": "次へ",
  "onboarding.who-is-on-your-team.title": "チームメンバーは?",
  "only.personal.labels.permitted": "このページでは個人用ラベルの追加のみ許可されています。",
  "org.randombits.confluence.toc.toc.label": "目次",
  "page.already.exists": "選択したスペースには同じタイトルの別のページが既に存在します。",
  "page.already.exists.inspace": "ページ '{'0'}' はすでにスペース '{'1'}' に存在します。移動する前にページ タイトルに別の名前を付けてください。",
  "page.change": "何を変更しましたか?",
  "page.comments.saved.dialog.message": "コメントはページコメントとして保存されました。",
  "page.comments.sidebar.warning": "このコンテンツにはインライン コメントを追加できません。代わりにページ コメントとして追加します。",
  "page.descendent.already.exists": "選択されたスペース内で別のページの同じタイトルを子孫ページが共有しています。",
  "page.permissions.menu.item.title": "制限",
  "page.permissions.menu.item.title.tooltip": "制限の編集",
  "page.tree.blankExperience.mainBanner": "潜在的なもの以外、ここには何もありません。",
  "page.tree.blankExperience.subBanner": "ミーティングのメモ、製品要件、ハウツー記事やその他のコンテンツを作成して、このスペースを埋めましょう。",
  "page.watch.instruction": "ページやブログ投稿をウォッチするには、‘ツール’ メニューを開き ‘ウォッチ’ をクリックします。",
  "page.watches": "ページのウォッチ",
  "page.word": "ページ",
  "pages.navigation.discovery.body.html": "<strong>ページ</strong>をクリックすると、ページ ツリーが表示され、このスペースのページを参照できます。",
  "pages.navigation.discovery.header": "ページツリーは今こちらにあります",
  "pages.show.all": "すべてのページを表示",
  "pages.word": "ページ",
  "pagetree.dragndrop.failed.action.visitsupport": "アトラシアン サポートにアクセス",
  "pagetree.dragndrop.failed.description": "ページを更新してもう一度お試しください。問題が継続する場合は、以下のリンクを使用してお問い合わせください。",
  "pagetree.dragndrop.failed.title": "エラーが発生しました。",
  "pagetree.failed.load.content": "ページツリーを読み込めませんでした",
  "pagetree.failed.load.tooltip": "この問題は早急に解決されますのでしばらくお待ちください。",
  "parent.page.invalid.for.space": "スペース <b>{1}</b> には <b>{0}</b> というタイトルのページはありません。",
  "parent.page.name": "親ページ",
  "pdf.file": "PDF ファイル",
  "people.directory.name": "ユーザー",
  "period.lastSevenDays": "先週",
  "period.lastThirtyDays": "先月",
  "period.older": "一ヶ月以上前",
  "period.today": "今日",
  "period.yesterday": "昨日",
  "permission.owner.not.in.group": "自分が所属するグループにのみページの権限を付与できます",
  "permission.owner.not.set": "権限のオーナーを選択してください",
  "permissions.comment": "ページの表示や編集を許可するユーザーを定義します。これらの権限を自分自身またはユーザー グループに制限できます。",
  "permissions.edit.title": "編集",
  "permissions.select.nopermissions": "未設定",
  "permissions.view.title": "表示",
  "person.follow": "注目",
  "person.follow.stop": "注目を中止",
  "personal.spaces": "個人用スペース",
  "placeholder.placeholdertext.label": "プレースホルダー テキスト",
  "placeholder.replacementtext.label": "置換テキスト",
  "please.enter.a.label": "ラベルを入力してください。",
  "png.file": "PNG ファイル",
  "popular.stream.mainBanner": "あまり動きもなく静かです...今のところ",
  "popular.stream.subBanner": "今は静かですが、チームが作成に取り掛かると、最もよく使われるページやファイルがこちらに表示されます。",
  "popular.stream.subBanner2": "さあ、パーティーを始めましょう!",
  "popular.stream.title": "人気のコンテンツ",
  "posted.word": "掲載済み",
  "powerpoint.file": "Microsoft Powerpoint プレゼンテーション",
  "powerpoint.macro.file": "Microsoft Powerpoint マクロ対応プレゼンテーション",
  "powerpoint.slideshow.file": "Microsoft Powerpoint スライドショー",
  "powerpoint.template.file": "Microsoft Powerpoint テンプレート",
  "powerpoint97.file": "Microsoft Powerpoint 97 スライドショー",
  "powerpoint97.template.file": "Microsoft Powerpoint 97 テンプレート",
  "product.name": "Confluence",
  "profile.page": "プロファイル ページ",
  "property.panel.macro.display.inline": "インライン表示",
  "property.panel.macro.display.newline": "新しい行に表示",
  "property.panel.macro.edit": "編集",
  "property.panel.macro.remove": "削除",
  "property.panel.textplaceholder.display.default": "テキスト",
  "property.panel.textplaceholder.display.default.tooltip": "ユーザーが入力すると説明テキストは空のコンテンツに置換されます。",
  "property.panel.textplaceholder.display.mention": "ユーザーのメンション",
  "property.panel.textplaceholder.display.mention.tooltip": "ユーザーが入力すると説明テキストは候補ユーザーに置換されます。",
  "property.panel.textplaceholder.remove": "削除",
  "property.panel.variable.display.list": "リスト",
  "property.panel.variable.display.list.tooltip": "ドロップダウンリスト。",
  "property.panel.variable.display.string": "テキスト",
  "property.panel.variable.display.string.tooltip": "1行テキストの入力フィールド。",
  "property.panel.variable.display.textarea": "複数行テキスト",
  "property.panel.variable.display.textarea.tooltip": "複数行テキスト入力フィールド。",
  "property.panel.variable.list.values.tooltip": "リストの各項目をそれぞれコンマ区切りで入力してください。",
  "property.panel.variable.textarea.columns.tooltip": "フィールドに表示するカラム数。",
  "property.panel.variable.textarea.rows.tooltip": "フィールドに表示する行数。",
  "quick.comment.placeholder.message": "コメントを書く…",
  "quick.reload.edit": "新規ページの編集",
  "quick.reload.edit.by": "編集者",
  "quick.reload.edit.more": "さらに{0}件",
  "quick.reload.edit.one.more": "さらに1件",
  "quick.reload.edits": "{0} 件の新規編集",
  "quick.reload.newcomments": "{0} 件の新規コメント",
  "quick.reload.newpagecomment": "新規コメント",
  "quick.reload.reload": "ページを再読み込み",
  "recently-updated-content-list.commented.new": "コメント作成日 : {time}",
  "recently-updated-content-list.created.new": "作成: {time}",
  "recently-updated-content-list.edited.new": "更新日: {time}",
  "recently.viewed.mainBanner": "歴史はここから始まります",
  "recently.viewed.subBanner": "現在はまだありませんが、閲覧したスペースはこちらにドロップされるので、すぐに戻れます。",
  "recently.viewed.subBanner2": "今すぐ<b>スペース</b>に移動して探検してみましょう。",
  "recently.viewed.title": "最近の閲覧",
  "recently.worked.mainBanner": "やりかけの傑作を完成させる",
  "recently.worked.subBanner": "現在はまだありませんが、作成・編集中のスペースはこちらにドロップされるので、中断後もすぐに作業を再開できます。",
  "recently.worked.subBanner2": "さあ、今すぐ移動して最大の傑作を生み出しましょう。",
  "recently.worked.title": "最近の作業",
  "remove.comment.confirmation.message": "このコメントを削除してもよろしいですか?",
  "remove.label": "ラベルの削除",
  "resize.image.dialog.title": "画像のサイズ変更",
  "restore.this.version": "復元してください",
  "result.grid.column.content.last.modified": "最終更新",
  "resume.editing": "再開",
  "return.to.page.info": "ページ情報に戻る",
  "satisfaction.survey.reaction.amazing": "とても素晴らしい",
  "satisfaction.survey.reaction.bad": "悪い",
  "satisfaction.survey.reaction.great": "素晴らしい",
  "satisfaction.survey.reaction.okay": "オーケー",
  "satisfaction.survey.reaction.terrible": "とても悪い",
  "save.name": "保存",
  "scheme.desc.custom": "編集可能なカスタム配色です。",
  "scheme.desc.global": "この配色では、グローバルに定義した配色をこのスペースに適用します。",
  "scheme.title.custom": "カスタム配色",
  "scheme.title.global": "グローバル配色",
  "search.drawer.recently.viewed": "最近表示したファイル",
  "search.drawer.recently.viewed.spaces": "最近閲覧したスペース",
  "search.name": "検索",
  "settings.name": "設定",
  "share.button.restriction.message.text": "このページに制限があるので、他の人が表示や編集を行えない可能性があります",
  "share.button.text": "共有",
  "show.more.blogposts": "ブログの投稿をさらに表示",
  "sidebar.avatar.picker.upload.error": "スペース情報の更新中にエラーが発生しました",
  "sidebar.main.back.to.overview": "概要に戻る",
  "sidebar.main.back.to.space": "スペースへ戻る",
  "sidebar.main.blog": "ブログ",
  "sidebar.main.quick.links": "スペース ショートカット",
  "sidebar.main.settings": "スペース設定",
  "sidebar.main.shortcuts": "リンク",
  "sidebar.main.wiki": "ページ",
  "site-settings.templates-and-blueprints.edit-button-label": "編集",
  "space.404.banner.title": "リンク切れです",
  "space.404.go.back": "に戻ってください",
  "space.404.go.to": "に進んでください",
  "space.404.home.page": "ホームページ",
  "space.404.previous.page": "前のページ",
  "space.create": "スペースの作成",
  "space.home.blog.blankExperience.mainBanner": "何か共有するものがありますか?",
  "space.home.blog.blankExperience.subBanner": "ブログ投稿は、お知らせや状況報告、その他の重要なニュースをあなたのチームと共有するのに素晴らしい方法です。",
  "space.home.overview.blankExperience.mainBanner": "これは少し問題があります。",
  "space.home.overview.blankExperience.subBanner": "このスペースにはホームページがないので、残念ながらここに表示するものはありません。",
  "space.home.overview.blankExperience.subBanner2": "今すぐホームページを加えて全体を刷新しましょう。それを利用して、このスペースの全てをビジターに紹介しましょう。",
  "space.not.exists": "指定したスペースは存在しません。",
  "space.personal.name": "個人用スペース",
  "space.set.space.home": "スペース ホームを設定",
  "space.watch.instruction": "スペース内のページやブログ投稿をウォッチするには、スペース サイドバーの [ページ] または [ブログ] をクリックしてください。",
  "space.watches": "スペースのウォッチ",
  "spaces.all": "すべてのスペース",
  "spaces.lookandfeel.help": "ここではこの Confluence スペースの外観をカスタマイズできます。",
  "spaces.lookandfeel.note": "<span class=\"errorMessage\">注意 :</span> <i>ここで行われるすべての変更は、管理者が設定した既定の配色と既定のデコレーターを上書きします。</i>",
  "spaces.word": "スペース",
  "starred.mainBanner": "ここには表示するものがありません...今のところ",
  "starred.spaces.tooltip.add": "このスペースにスターを追加",
  "starred.spaces.tooltip.remove": "このスペースからスターを外す",
  "starred.subBanner": "ページを保存するには、<b>星のアイコン</b>をクリックしてください。後で必要な時に見つけやすいように、こちらへ保存しておきます。",
  "starred.title": "後で読む",
  "status.lozenge.draft": "下書き",
  "status.lozenge.unpublished": "未公表の変更",
  "submit.name": "送信",
  "super-admin.banner.exit": "管理者キーの使用を停止",
  "super-admin.banner.message": "管理者キーを使用しているため、制限付きコンテンツに一時的にアクセスできます。",
  "switch.apps": "アプリの切り替え",
  "system.help.legal": "法的事項",
  "team.create.flag.error.description": "チームを作成できませんでした。もう一度お試しください。",
  "team.create.flag.error.title": "エラーが発生しました！",
  "team.created.flag.description": "{membersCount, plural, other {チーム '{'teamName'}' に {membersCount} 人のメンバーを招待しました}}",
  "team.created.flag.title": "新しいチームが作成されました",
  "team.created.flag.view": "チームを表示",
  "template.variables.fabric.section.message": "このテンプレートは変数を使用しています。ここに入力した情報は新しいページのコンテンツの一部として公開されます。",
  "templates.name": "テンプレート",
  "text.file": "テキスト ファイル",
  "text.selected": "選択済み",
  "tinymce.advanced.block": "書式",
  "tinymce.advanced.blockquote": "引用符",
  "tinymce.advanced.blockquote_shortcut": "Ctrl+8",
  "tinymce.advanced.bold_desc": "太字",
  "tinymce.advanced.bold_shortcut": "Ctrl+B",
  "tinymce.advanced.bullist_desc": "記号付きリスト",
  "tinymce.advanced.bullist_shortcut": "Ctrl+Shift+B",
  "tinymce.advanced.charmap_desc": "記号",
  "tinymce.advanced.forecolor_desc": "テキストの色の選択",
  "tinymce.advanced.formatting_desc": "書式設定",
  "tinymce.advanced.h1": "見出し 1",
  "tinymce.advanced.h1_shortcut": "Ctrl+1",
  "tinymce.advanced.h2": "見出し 2",
  "tinymce.advanced.h2_shortcut": "Ctrl+2",
  "tinymce.advanced.h3": "見出し 3",
  "tinymce.advanced.h3_shortcut": "Ctrl+3",
  "tinymce.advanced.h4": "見出し 4",
  "tinymce.advanced.h4_shortcut": "Ctrl+4",
  "tinymce.advanced.h5": "見出し 5",
  "tinymce.advanced.h5_shortcut": "Ctrl+5",
  "tinymce.advanced.h6": "見出し 6",
  "tinymce.advanced.h6_shortcut": "Ctrl+6",
  "tinymce.advanced.headings": "見出し 1 から 6",
  "tinymce.advanced.headings_shortcut": "Ctrl+1..6",
  "tinymce.advanced.hr_desc": "水平ルーラー",
  "tinymce.advanced.indent_desc": "インデント",
  "tinymce.advanced.italic_desc": "斜体",
  "tinymce.advanced.italic_shortcut": "Ctrl+I",
  "tinymce.advanced.justifycenter_desc": "中央揃え",
  "tinymce.advanced.justifyfull_desc": "両端揃え",
  "tinymce.advanced.justifyleft_desc": "左揃え",
  "tinymce.advanced.justifyright_desc": "右揃え",
  "tinymce.advanced.numlist_desc": "番号付きリスト",
  "tinymce.advanced.numlist_shortcut": "Ctrl+Shift+N",
  "tinymce.advanced.outdent_desc": "インデント解除",
  "tinymce.advanced.paragraph": "段落",
  "tinymce.advanced.paragraph_shortcut": "Ctrl+0",
  "tinymce.advanced.pre": "書式設定済み",
  "tinymce.advanced.pre_shortcut": "Ctrl+7",
  "tinymce.advanced.redo_desc": "やり直し",
  "tinymce.advanced.redo_shortcut": "Ctrl+Y",
  "tinymce.advanced.striketrough_desc": "取り消し線",
  "tinymce.advanced.striketrough_shortcut": "Ctrl+Shift+S",
  "tinymce.advanced.sub_desc": "下付き文字",
  "tinymce.advanced.sup_desc": "上付き文字",
  "tinymce.advanced.tasklist_desc": "タスク リスト",
  "tinymce.advanced.tasklist_shortcut": "[ の後に ]",
  "tinymce.advanced.underline_desc": "下線",
  "tinymce.advanced.underline_shortcut": "Ctrl+U",
  "tinymce.advanced.undo_desc": "元に戻す",
  "tinymce.advanced.undo_shortcut": "Ctrl+Z",
  "tinymce.advanced.unlink_desc": "リンクの解除",
  "tinymce.atlassian.help": "ヘルプ",
  "tinymce.atlassian.insert_menu": "挿入",
  "tinymce.atlassian.insert_menu.charmap_desc": "記号を挿入します",
  "tinymce.atlassian.insert_menu.content_desc": "コンテンツを挿入します",
  "tinymce.atlassian.insert_menu.hr_desc": "水平ルーラーの挿入 (----)",
  "tinymce.atlassian.insert_menu.macro_desc": "マクロを挿入します",
  "tinymce.atlassian.insert_menu.tooltip": "さらにコンテンツを挿入します",
  "tinymce.atlassian.monospace": "等幅フォント",
  "tinymce.atlassian.monospace_desc": "等幅フォントでテキストの書式設定",
  "tinymce.atlassian.more_menu": "詳細",
  "tinymce.atlassian.remove_formatting": "書式のクリア",
  "tinymce.atlassian.remove_formatting_desc": "現在選択しているテキストの書式設定をクリア",
  "tinymce.auiwindowmanager.cancel": "キャンセル",
  "tinymce.auiwindowmanager.ok": "OK",
  "tinymce.autocomplete.web.resource.name": "Confluence オートコンプリート Web リソース",
  "tinymce.autocomplete.web.resource.only.name": "Confluence オートコンプリート Web リソース (依存関係なし)",
  "tinymce.charmap.web.resource.name": "TinyMCE文字マップWebリソース",
  "tinymce.charmap_dlg.title": "記号の挿入",
  "tinymce.colorpicker.color": "色",
  "tinymce.colorpicker.more_colors": "その他の色",
  "tinymce.colorpicker.picker_tab": "ピッカー",
  "tinymce.colorpicker.picker_title": "カラー ピッカー",
  "tinymce.colorpicker.title": "色の選択",
  "tinymce.colorpicker.web.resource.name": "Confluence カラーピッカー Web リソース",
  "tinymce.confluence.conf_emoji": "絵文字",
  "tinymce.confluence.conf_emoticon": "絵文字",
  "tinymce.confluence.conf_emoticon_desc": "絵文字を挿入します",
  "tinymce.confluence.conf_file": "ファイルと画像",
  "tinymce.confluence.conf_file_desc": "ファイルと画像を挿入します",
  "tinymce.confluence.conf_file_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_image": "画像",
  "tinymce.confluence.conf_image_desc": "画像を挿入します",
  "tinymce.confluence.conf_image_shortcut": "Ctrl+M",
  "tinymce.confluence.conf_link": "リンク",
  "tinymce.confluence.conf_link_desc": "リンクを挿入します",
  "tinymce.confluence.conf_link_shortcut": "Ctrl+K",
  "tinymce.confluence.conf_macro_browser": "マクロ",
  "tinymce.confluence.conf_macro_browser_desc": "マクロを挿入します",
  "tinymce.confluence.conf_macro_browser_shortcut": "Ctrl+Shift+A",
  "tinymce.confluence.conf_media": "画像/メディア",
  "tinymce.confluence.conf_other_macros_desc": "その他のマクロ...",
  "tinymce.confluence.conf_shortcuts_help": "キーボードショートカット ヘルプ",
  "tinymce.confluence.conf_tasklist": "タスクリスト",
  "tinymce.confluence.conf_tasklist_desc": "タスクリストを挿入します",
  "tinymce.confluence.conf_tasklist_shortcut": "[ の後に ]",
  "tinymce.confluence.conf_widget_desc": "ウィジェット",
  "tinymce.confluence.conf_wikimarkup": "マークアップ",
  "tinymce.confluence.conf_wikimarkup.insert.label": "挿入",
  "tinymce.confluence.conf_wikimarkup_confluence_label": "Confluence Wiki",
  "tinymce.confluence.conf_wikimarkup_conversion_errors": "Wikiマークアップ変換エラー",
  "tinymce.confluence.conf_wikimarkup_desc": "マークアップを挿入します",
  "tinymce.confluence.conf_wikimarkup_hint": "ヒント : エディターで直接 wiki マークアップを入力することができ、入力したとおりに書式設定されます。",
  "tinymce.confluence.conf_wikimarkup_info_title": " 以下にWikiマークアップ/マークダウンを入力してください。 Confluenceはコンテンツをエディター形式に変換しページ内に挿入します。",
  "tinymce.confluence.conf_wikimarkup_markdown_label": "マークダウン",
  "tinymce.confluence.conf_wikimarkup_preview_label": "プレビュー",
  "tinymce.confluence.conf_wikimarkup_shortcut": "Ctrl+Shift+D",
  "tinymce.confluence.conf_wikimarkup_timeout": "サーバーは、wiki マークアップを変換に時間がかかっています。一時的な問題であるかもしれませんので、再度やり直してください。",
  "tinymce.confluence.files": "ファイル",
  "tinymce.confluence.help_desc": "ヘルプ",
  "tinymce.confluence.htmlsource": "ソース",
  "tinymce.confluence.htmlsource_desc": "HTMLソースを表示します",
  "tinymce.confluence.layout.menu": "ページレイアウト",
  "tinymce.confluence.layout.none": "レイアウトがありません",
  "tinymce.confluence.layout.three_col": "3 カラム",
  "tinymce.confluence.layout.three_col_sidebars": "3 カラム (左右サイドバー)",
  "tinymce.confluence.layout.three_col_simple": "3 カラム (シンプル)",
  "tinymce.confluence.layout.two_col": "2 カラム",
  "tinymce.confluence.layout.two_col_left": "2 カラム (左サイドバー)",
  "tinymce.confluence.layout.two_col_right": "2 カラム (右サイドバー)",
  "tinymce.confluence.layout.two_col_simple": "2 カラム (シンプル)",
  "tinymce.confluence.layout.two_col_simple_left": "2 カラム (シンプル、左サイドバー)",
  "tinymce.confluence.layout.two_col_simple_right": "2 カラム (シンプル、右サイドバー)",
  "tinymce.confluence.macro_insert": "'{'0'}' マクロの挿入",
  "tinymce.confluence.macro_other": "その他のマクロ...",
  "tinymce.confluence.macro_other_desc": "マクロ ブラウザーを開く",
  "tinymce.confluence.placeholder.inline.tasks": "ユーザーを割り当てるには\"@\"、締切を選択するには\"//\"を使用して、ここにタスクを入力してください",
  "tinymce.confluence.preview": "プレビュー",
  "tinymce.confluence.preview_shortcut": "Ctrl+Shift+E",
  "tinymce.confluence.save_shortcut": "Ctrl+S",
  "tinymce.confluence.settings_desc": "エディター設定です",
  "tinymce.confluence_dlg.insertbutton.title": "挿入",
  "tinymce.confluence_dlg.insertimage.title": "画像の挿入",
  "tinymce.confluence_dlg.insertlink.title": "リンクの挿入",
  "tinymce.emotions.emotions_desc": "絵文字",
  "tinymce.emotions.web.resource.name": "TinyMCE絵文字Webリソース",
  "tinymce.emotions_dlg.add": "プラス (+)",
  "tinymce.emotions_dlg.biggrin": "スマイル :D",
  "tinymce.emotions_dlg.broken_heart": "壊れたハート </3",
  "tinymce.emotions_dlg.check": "ティック (/)",
  "tinymce.emotions_dlg.desc": "絵文字",
  "tinymce.emotions_dlg.error": "エラー (x)",
  "tinymce.emotions_dlg.forbidden": "マイナス (-)",
  "tinymce.emotions_dlg.heart": "ハート <3",
  "tinymce.emotions_dlg.help_16": "疑問符(?)",
  "tinymce.emotions_dlg.information": "情報 (i)",
  "tinymce.emotions_dlg.lightbulb": "電球オフ (off)",
  "tinymce.emotions_dlg.lightbulb_on": "電球オン (on)",
  "tinymce.emotions_dlg.sad": "悲しい :(",
  "tinymce.emotions_dlg.smile": "スマイル :)",
  "tinymce.emotions_dlg.star_blue": "青い星印 (*b)",
  "tinymce.emotions_dlg.star_green": "緑の星印 (*g)",
  "tinymce.emotions_dlg.star_red": "赤い星印 (*r)",
  "tinymce.emotions_dlg.star_yellow": "黄色い星印 (*y)",
  "tinymce.emotions_dlg.thumbs_down": "よくないね! (n)",
  "tinymce.emotions_dlg.thumbs_up": "いいね! (y)",
  "tinymce.emotions_dlg.title": "絵文字の挿入",
  "tinymce.emotions_dlg.tongue": "ペロリ :p",
  "tinymce.emotions_dlg.warning": "警告 (!)",
  "tinymce.emotions_dlg.wink": "ウィンク ;)",
  "tinymce.fabric.migration.dialog.action": "編集を続行",
  "tinymce.fabric.migration.dialog.content": "ページが更新されただけで変更は失われませんので、ご安心ください。",
  "tinymce.fabric.migration.dialog.title": "編集機能を更新しました",
  "tinymce.formatting.paragraph": "通常のテキスト",
  "tinymce.full_screen.toolbar_item": "フルスクリーン",
  "tinymce.full_screen.toolbar_item_title": "エディターを全画面で表示",
  "tinymce.hints.autoformat.code": "ヒント:「<strong>'{{'code'}}'</strong>」を入力することで、等幅のテキストがすぐに挿入されます。",
  "tinymce.hints.autoformat.heading1": "ヒント : <strong>\"h1. タイトル\"</strong> と入力することで、見出し 1 がすぐに挿入されます。",
  "tinymce.hints.autoformat.heading3": "ヒント : <strong>\"h3. タイトル\"</strong> と入力することで、見出し 3 がすぐに挿入されます。",
  "tinymce.hints.dnd": "ヒント : コンピュータにある画像や Office ファイルをこのエディターの右側にドラッグ アンド ドロップできます。",
  "tinymce.hints.drafts": "ヒント : Confluence は自動的に下書きを保存します。ウィンドウを閉じた場合は、\"ユーザー名 -> 下書き\" メニューから作業を再開してください。",
  "tinymce.hints.insert.bullet.list": "ヒント : <strong>Ctrl+Shift+B</strong> を押すことで、箇条書きリストが開始されます。",
  "tinymce.hints.insert.heading": "ヒント : <strong>Ctrl+1</strong> を押すことで、見出しレベル 1 が作成されます。見出しレベル 2 以降は <strong>Ctrl+2</strong> のようになります。",
  "tinymce.hints.insert.image": "ヒント : <strong>Ctrl+M</strong> を押すことで、画像ブラウザーが表示されます。",
  "tinymce.hints.insert.image.end": "ヒント : 単語の後で <strong>Ctrl+Shift+M</strong> を押すことで、関連する画像の検索ならびに挿入が可能です。",
  "tinymce.hints.insert.image.on.page": "ヒント : \"<strong>!</strong>\" と入力することで、そのページに添付されている画像の確認ならびに挿入が可能です。",
  "tinymce.hints.insert.image.search": "ヒント : \"<strong>!</strong>\" および画像名の一部を入力することで、その画像の検索ならびに挿入が可能です。",
  "tinymce.hints.insert.link": "ヒント : <strong>Ctrl+K</strong> を押すことで、リンク ブラウザーが表示されます。",
  "tinymce.hints.insert.link.end": "ヒント : 単語の後で <strong>Ctrl+Shift+K</strong> を押すことで、関連するページの検索ならびにそれらページへのリンク作成が可能です。もう一度押すと、さらなる候補が表示されます。",
  "tinymce.hints.insert.link.newpage": "ヒント : <strong>\"[\"</strong> を入力することで、作成したい新しいページのタイトルおよび挿入するリンク候補の確認が可能です。",
  "tinymce.hints.insert.link.recently.viewed": "ヒント : \"<strong>[</strong>\" と入力することで、推奨ページ一覧の確認ならびにリンクの挿入が可能です。",
  "tinymce.hints.insert.link.search": "ヒント : \"<strong>[</strong>\" およびページ タイトルの一部を入力することで、そのページの検索ならびにそのページへのリンク作成が可能です。",
  "tinymce.hints.insert.link.user.mention": "ヒント : \"<strong>@</strong>\" に続けて名前を入力することによりユーザーをメンションできます。",
  "tinymce.hints.insert.macro": "ヒント : <strong>Ctrl+Shift+A</strong> を押すことで、マクロ ブラウザーが表示されます。",
  "tinymce.hints.insert.macro.toc": "使い方のヒント: Confluenceはこのページの目次を自動作成できます。 \"挿入 -> 目次\"を使用",
  "tinymce.hints.insert.newline": "ヒント : <strong>Shift+Enter</strong> を押すことで、間隔なしの新しい段落が挿入されます",
  "tinymce.hints.insert.numbered.list": "ヒント : <strong>Ctrl+Shift+N</strong> を押すことで、番号付きリストが開始されます。",
  "tinymce.hints.insert.table": "ヒント : <strong>Ctrl+Shift+I</strong> を押すことで、表が挿入されます。",
  "tinymce.hints.insert.wikimarkup": "ヒント : Wiki マークアップを入力すると、エディターは自動的に変換します。",
  "tinymce.hints.insert.wikimarkup.dialog": "ヒント : <strong>Ctrl+Shift+D</strong> を押すことで、Wiki マークアップのダイアログを開きます。",
  "tinymce.hints.table.rows.copy": "ヒント: <strong>Ctrl+Shift+C</strong> を押すことで、行をコピーします。<strong>Ctrl+Shift+V</strong> の場合は、表内に行を貼り付けます。",
  "tinymce.hints.table.rows.cut": "ヒント: <strong>Ctrl+Shift+X</strong> を押すことで、行をカットします。<strong>Ctrl+Shift+V</strong> の場合は、表内に行を貼り付けます。",
  "tinymce.macro.preview.exception": "マクロのプレビュー中に例外が発生しました。例外 : {0}",
  "tinymce.macro.unknownMacro": "マクロ '{'0'}' は不明です。システムから削除された可能性があります。",
  "tinymce.popup_blocked": "ブラウザーは、エディターで開かれたポップアップをブロックしました。",
  "tinymce.propertypanel.images.border": "枠線",
  "tinymce.propertypanel.images.border.tooltip": "画像の周りに枠線を表示",
  "tinymce.propertypanel.images.large": "大",
  "tinymce.propertypanel.images.large.tooltip": "画像を大サイズに変更して元の画像にリンク",
  "tinymce.propertypanel.images.link.create": "リンク",
  "tinymce.propertypanel.images.link.create.tooltip": "他のコンテンツにこの画像をリンク",
  "tinymce.propertypanel.images.link.edit": "リンクを編集",
  "tinymce.propertypanel.images.link.edit.tooltip": "この画像のリンクを編集",
  "tinymce.propertypanel.images.link.remove": "リンク解除",
  "tinymce.propertypanel.images.link.remove.tooltip": "この画像のリンクを削除",
  "tinymce.propertypanel.images.medium": "中",
  "tinymce.propertypanel.images.medium.tooltip": "画像を中サイズに変更して元の画像にリンク",
  "tinymce.propertypanel.images.original": "元の画像",
  "tinymce.propertypanel.images.original.tooltip": "画像を元のサイズにリセット",
  "tinymce.propertypanel.images.sizing.tooltip": "画像を指定した幅に変更",
  "tinymce.propertypanel.images.small": "小",
  "tinymce.propertypanel.images.small.tooltip": "画像を小サイズに変更して元の画像にリンク",
  "tinymce.propertypanel.links.edit": "編集",
  "tinymce.propertypanel.links.edit.tooltip": "ダイアログでリンクを編集",
  "tinymce.propertypanel.links.goto": "リンクへ移動",
  "tinymce.propertypanel.links.goto.disabled.tooltip": "このリンクは、編集しているページのコンテンツを開きます",
  "tinymce.propertypanel.links.unlink": "リンク解除",
  "tinymce.propertypanel.links.unlink.tooltip": "リンクをリンク テキストに置き換え",
  "tinymce.searchreplace.replace_desc": "検索/置換",
  "tinymce.searchreplace.search_desc": "検索",
  "tinymce.searchreplace_dlg.allreplaced.plural": "{0} 個の置換を行いました",
  "tinymce.searchreplace_dlg.allreplaced.singular": "1 個の置換を行いました",
  "tinymce.searchreplace_dlg.close": "クローズ",
  "tinymce.searchreplace_dlg.direction": "方向",
  "tinymce.searchreplace_dlg.down": "下へ",
  "tinymce.searchreplace_dlg.findlabel": "検索",
  "tinymce.searchreplace_dlg.findnext": "次へ",
  "tinymce.searchreplace_dlg.findprevious": "前へ",
  "tinymce.searchreplace_dlg.findwhat": "検索文字列",
  "tinymce.searchreplace_dlg.mcase": "大文字/小文字を区別",
  "tinymce.searchreplace_dlg.notfound": "置換は行われませんでした",
  "tinymce.searchreplace_dlg.replace": "置換",
  "tinymce.searchreplace_dlg.replace_title": "検索/置換",
  "tinymce.searchreplace_dlg.replaceall": "全て置換",
  "tinymce.searchreplace_dlg.replacelabel": "置換",
  "tinymce.searchreplace_dlg.search_title": "検索",
  "tinymce.searchreplace_dlg.searchnext_desc": "再検索",
  "tinymce.searchreplace_dlg.up": "上へ",
  "tinymce.style.show-eol-markers": "¶",
  "tinymce.style.show-eol-markers.title": "ラインマーカーの末尾を表示/非表示",
  "tinymce.table": "表",
  "tinymce.table.cell": "セル",
  "tinymce.table.col": "列",
  "tinymce.table.col_after_desc": "後に列を挿入",
  "tinymce.table.col_after_desc_shortcut_mac": "Control+オプション+→",
  "tinymce.table.col_after_desc_shortcut_win": "Alt+Shift+→",
  "tinymce.table.col_before_desc": "前に列を挿入",
  "tinymce.table.col_before_desc_shortcut_mac": "Control+オプション+←",
  "tinymce.table.col_before_desc_shortcut_win": "Alt+Shift+←",
  "tinymce.table.col_copy_desc": "テーブル列をコピーします",
  "tinymce.table.col_cut_desc": "テーブル列を切り取ります",
  "tinymce.table.col_highlight": "見出し列",
  "tinymce.table.col_paste_desc": "テーブル列を貼り付けます",
  "tinymce.table.copy_row_desc": "表の行をコピー",
  "tinymce.table.copy_row_shortcut": "Ctrl+Shift+C",
  "tinymce.table.cut_row_desc": "表の行を切り取り",
  "tinymce.table.cut_row_shortcut": "Ctrl+Shift+X",
  "tinymce.table.del": "表の削除",
  "tinymce.table.delete_col_desc": "列を削除",
  "tinymce.table.delete_row_desc": "行を削除",
  "tinymce.table.desc": "表を挿入",
  "tinymce.table.fixed_width": "固定幅",
  "tinymce.table.fixed_width_tooltip": "列をドラッグして幅を設定してください。表は常に設定した幅で表示されます。",
  "tinymce.table.highlight_colour": "強調色",
  "tinymce.table.merge_cells_desc": "表のセルを結合",
  "tinymce.table.more.heading": "テーブル設定",
  "tinymce.table.numbering_column_desc": "ナンバリング列を挿入します",
  "tinymce.table.paste_row_after_desc": "後に行を挿入",
  "tinymce.table.paste_row_before_desc": "表の行を貼り付け",
  "tinymce.table.paste_row_before_shortcut": "Ctrl+Shift+V",
  "tinymce.table.responsive": "レスポンシブ",
  "tinymce.table.responsive_tooltip": "コンテンツを追加すると、表の列は広くなります。それぞれのページと比較しながら列の境界線をドラッグして幅を設定してください。",
  "tinymce.table.row": "行",
  "tinymce.table.row_after_desc": "後に行を挿入",
  "tinymce.table.row_after_desc_shortcut_mac": "Control+オプション+↓",
  "tinymce.table.row_after_desc_shortcut_win": "Alt+Shift+↓",
  "tinymce.table.row_after_shortcut": "Alt+↓",
  "tinymce.table.row_before_desc": "前に行を挿入",
  "tinymce.table.row_before_desc_shortcut_mac": "Control+オプション+↑",
  "tinymce.table.row_before_desc_shortcut_win": "Alt+Shift+↑",
  "tinymce.table.row_before_shortcut": "Alt+↑",
  "tinymce.table.row_highlight": "見出し行",
  "tinymce.table.selection_highlight": "セルの色を変更",
  "tinymce.table.split_cells_desc": "表のセル結合を解除",
  "tinymce.table_dlg.cols": "列",
  "tinymce.table_dlg.equal.width.columns": "等幅の列",
  "tinymce.table_dlg.fullwidth": "全幅",
  "tinymce.table_dlg.heading": "最初の行を見出しにする",
  "tinymce.table_dlg.invalid_table_field": "行と列はどちらも 0 より大きい数字である必要があります。",
  "tinymce.table_dlg.rows": "行",
  "tinymce.table_dlg.sizetofit": "コンテンツのサイズ",
  "tinymce.table_dlg.title": "テーブルの挿入",
  "tinymce.table_dlg.width": "幅",
  "tinymce.table_shortcut": "Ctrl+Shift+I",
  "tinymce.tablepicker.insert_table": "表",
  "tinymce.tablepicker.insert_table_title": "テーブルの挿入",
  "tinymce.tablepicker.nested_table_unsupported": "ネスト表はサポートされていません。",
  "tinymce.tablepicker.pickerbox.tooltip": "Shift キーを押しながら、見出しなしの表を作成します。",
  "tinymce.templates.actions.defined": "このページに挿入するアイテム。",
  "tinymce.templates.insert-template": "テンプレート",
  "tinymce.templates.insert-template.tooltip": "このページにテンプレート アイテムを挿入します。",
  "tinymce.templates.placeholder": "説明",
  "tinymce.templates.placeholder.add": "プレースホルダー",
  "tinymce.templates.placeholder.add.tooltip": "ページにテキスト プレースホルダーを挿入します。",
  "tinymce.templates.placeholder.tooltip": "ユーザーが入力すると消え、ページの表示中に表示されません。",
  "tinymce.templates.variables.add": "新規変数",
  "tinymce.templates.variables.add.tooltip": "テンプレートのユーザーが入力するページに新規フィールドを追加します。",
  "tinymce.templates.variables.defined": "このページに挿入する変数。",
  "tinymce.templates.variables.insert.tooltip": "テンプレートのユーザーが入力するページに '{'0'}' フィールドを挿入します。",
  "tinymce.templates.variables.manage": "変数を管理",
  "tinymce.templates.variables.none": "変数を定義していません",
  "tinymce.templates.variables.none.tooltip": "変数が作成されていません。",
  "tinymce.tools.toolbar_item_hide": "ツールを非表示",
  "tinymce.tools.toolbar_item_hide_title": "ツールバーの非表示",
  "tinymce.tools.toolbar_item_show": "ツールを表示",
  "tinymce.tools.toolbar_item_show_title": "ツールバーの表示",
  "tinymce.web.css.resource.name": "Confluence エディター CSS Web リソース",
  "tinymce.web.js.resource.name": "Confluence エディター Javascript Webリソース",
  "tinymce.web.resource.name": "Confluence エディター Web リソース",
  "title.add.blogpost": "ブログ投稿の追加",
  "title.add.page": "ページの追加",
  "title.add.page.template": "テンプレートを作成",
  "title.comment": "コメント",
  "title.dashboard": "ダッシュボード",
  "title.edit.page.template": "テンプレートを編集",
  "title.manage.groups": "グループ",
  "title.name": "タイトル",
  "type.allcontent": "すべてのコンテンツ",
  "unknown.file": "ファイル",
  "unsaved.comment.lost": "コメントは失われます。",
  "unsaved.content.lost": "実行した変更は保存されない可能性があります。",
  "unsaved.template.lost": "保存していないテンプレートの変更は失われます。",
  "untitled.draft.title": "無題",
  "upm.marketplace.section": "Atlassian Marketplace",
  "usermanagement.label": "ユーザー管理",
  "usermanagement.parent.label": "サイト管理",
  "users.name": "ユーザー",
  "view-changes-dialog.close.dialog": "閉じる",
  "view-changes-dialog.editor.quit-dialog.title.diff": "未公表の変更",
  "view.change": "変更を表示",
  "view.profile": "プロファイルを表示",
  "viewdrafts.page.desc": "ページを編集したものの、変更を公開しなくても、下書きは作成されます。<b>再開</b>を押して編集を続けたり、変更を公開したりしてください。",
  "welcome.message.edit": "有用なリンク、お知らせ、情報をここでシェアします",
  "welcome.message.edit.link": "カスタマイズ",
  "word.file": "Microsoft Word 文書",
  "word.template.file": "Microsoft Word テンプレート",
  "word97.file": "Microsoft Word 97 文書",
  "word97.template.file": "Microsoft Word 97 テンプレート",
  "xml.file": "XML ファイル",
  "yes.name": "はい",
  "your.profile.and.settings": "あなたのプロフィールと設定",
  "zip.file": "ZIP アーカイブ"
}